import * as React from "react"
import { SVGProps } from "react"
const VisitCountAnimated = (props: SVGProps<SVGSVGElement>) => (
  <svg
    className="animated"
    id="freepik_stories-orthopedic"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 750 500"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
    width={250}
    height={250}
  >
    <style>
      {
        "svg#freepik_stories-orthopedic:not(.animated) .animable {opacity: 0;}svg#freepik_stories-orthopedic.animated #freepik--Poster--inject-359 {animation: 1.5s Infinite  linear floating;animation-delay: 0s;}svg#freepik_stories-orthopedic.animated #freepik--Characters--inject-359 {animation: 1.4s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideLeft;animation-delay: 0s;}            @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes slideLeft {                0% {                    opacity: 0;                    transform: translateX(-30px);                }                100% {                    opacity: 1;                    transform: translateX(0);                }            }"
      }
    </style>
    <g
      id="freepik--Negatoscope--inject-359"
      style={{
        transformOrigin: "515.375px 199.925px 0px",
      }}
      className="animable"
    >
      <path
        d="M601.06,297.1H429.69a.51.51,0,0,1-.5-.5V103.25a.5.5,0,0,1,.5-.5H601.06a.5.5,0,0,1,.5.5V296.6A.5.5,0,0,1,601.06,297.1Zm-170.87-1H600.56V103.75H430.19Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "515.375px 199.925px 0px",
        }}
        id="elw1n56bdf7f"
        className="animable"
      />
      <path
        d="M595.51,297.1H429.69a.51.51,0,0,1-.5-.5V103.25a.5.5,0,0,1,.5-.5H595.51a.5.5,0,0,1,.5.5V296.6A.51.51,0,0,1,595.51,297.1Zm-165.32-1H595V103.75H430.19Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "512.6px 199.925px 0px",
        }}
        id="elcy1cz7b0h2"
        className="animable"
      />
      <rect
        x={437.67}
        y={114.53}
        width={142.51}
        height={165.48}
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "508.925px 197.27px 0px",
        }}
        id="eljp44rzckykb"
        className="animable"
      />
      <path
        d="M580.68,280.5H437.17V114H580.68Zm-142.51-1H579.68V115H438.17Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "508.925px 197.25px 0px",
        }}
        id="elhmiga8wyx6r"
        className="animable"
      />
      <path
        d="M448.49,278.49c1.78.26,4.08-.76,4.08-1.78s-.26-13,.76-14.79,3.31-7.39,3.31-7.39,3.83,11.21,3.83,12.49c0,.89.49,8.48.79,13h34.39c-.56-7.31-1.84-24.38-2-27.77-.26-4.33-8.67-21.15-8.67-21.15l-4.08-7.65s2-13,2.55-17.08,5.61-24.73,6.12-33.65-2-30.33-2-30.33L483,114.53H444.05L455.88,150s-2,30.08-.26,42.07-1.27,39-1.27,39-10.45,15.8-10.45,16.82-.77,18.35-.51,21.67S446.7,278.24,448.49,278.49Z"
        style={{
          fill: "rgb(150, 150, 150)",
          transformOrigin: "469.493px 197.275px 0px",
        }}
        id="elwrs1sb7j6qn"
        className="animable"
      />
      <path
        d="M496.19,280.5H460.8l0-.46c-.36-5.47-.79-12.16-.79-13s-1.92-6.76-3.37-11.07c-.74,1.76-2.1,4.93-2.84,6.22-.31.56-.83,3.11-.7,13.94v.6a1.61,1.61,0,0,1-.65,1.2,5.52,5.52,0,0,1-4,1.08c-2.21-.32-5.27-6-5.53-9.38-.2-2.55.19-13,.4-18.58.06-1.7.11-2.88.11-3.13,0-1.05,7.26-12.15,10.47-17,.21-2,2.95-27.38,1.26-38.75-1.72-11.56.12-40.16.24-42.07l-12-36.05h40l4.6,28.26c0,.23,2.55,21.58,2,30.44-.34,6-2.69,17-4.4,25-.87,4.07-1.55,7.29-1.72,8.64-.48,3.79-2.29,15.41-2.53,16.93l4,7.5c.35.7,8.47,17,8.73,21.37.18,3.2,1.35,18.77,2,27.76Zm-34.46-1h33.38c-.69-9.06-1.82-24.08-2-27.24-.25-4.18-8.53-20.79-8.62-21l-4.15-7.78,0-.17c0-.13,2-13,2.54-17.06.18-1.4.87-4.63,1.74-8.72,1.7-8,4-19,4.38-24.9.5-8.77-2-30-2-30.24L482.53,115H444.74L456.39,150v.1c0,.3-2,30.16-.26,41.95s-1.24,38.86-1.27,39.13l0,.12-.06.1c-3.9,5.89-10.16,15.61-10.38,16.6,0,.2,0,1.39-.1,3.12-.19,5.18-.59,16-.4,18.46.25,3.25,3.23,8.26,4.67,8.47h0a4.57,4.57,0,0,0,3.2-.85.76.76,0,0,0,.31-.44v-.59c-.1-8.56.17-13.28.84-14.45,1-1.73,3.26-7.28,3.28-7.33l.51-1.24.43,1.27c.39,1.15,3.85,11.33,3.85,12.65C461,267.65,461.24,272.08,461.73,279.5Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "469.527px 197.275px 0px",
        }}
        id="elfe51w3z8h9j"
        className="animable"
      />
      <path
        d="M523.07,280H546c-.53-6.91-2.27-29.83-2-32.85a44.42,44.42,0,0,1,.82-7.41c.55-2.19,14-62.27,14.27-65s6.86-30.45,6.86-32.92c0-1.65,2.45-17.19,4.08-27.28H534l1.69,10.28s-7.13,28.25-6,43.61-.28,49.1-.28,55.14-2.47,15.63-2.47,15.63-6,10.7-6,14,2.19,19.2,2.19,20.57Z"
        style={{
          fill: "rgb(150, 150, 150)",
          transformOrigin: "545.485px 197.27px 0px",
        }}
        id="elxnuf02ehb8n"
        className="animable"
      />
      <path
        d="M546.5,280.5H522.57v-6.75c0-.5-.34-3.34-.74-6.62-.65-5.31-1.45-11.92-1.45-13.95,0-3.29,5.53-13.23,6.07-14.18.21-.83,2.43-9.79,2.43-15.44,0-1.49.09-4.7.19-8.77.34-13,.91-34.76.09-46.33-1.06-14.81,5.55-41.8,6-43.67L533.42,114h37.12l-.1.58c-2.63,16.32-4.07,26-4.07,27.2,0,1.44-2,10.49-4,19.24-1.43,6.46-2.79,12.56-2.9,13.73-.31,3.09-14.15,64.56-14.28,65.08a27.43,27.43,0,0,0-.66,5.23c0,.62-.09,1.31-.15,2.1-.23,3,1.5,25.84,2,32.78Zm-22.93-1h21.85c-.58-7.52-2.23-29.42-2-32.39.06-.78.11-1.47.15-2.09a28.74,28.74,0,0,1,.69-5.4c.13-.52,14-62.08,14.25-64.94.12-1.23,1.42-7.08,2.92-13.84,1.76-7.89,3.94-17.7,3.94-19,0-1.6,2.15-15.31,4-26.78H534.59l1.61,9.8,0,.1c-.07.28-7.1,28.35-6,43.46.83,11.61.25,33.41-.09,46.42-.1,4.07-.19,7.27-.19,8.75,0,6-2.38,15.36-2.48,15.76l0,.12c-.06.1-6,10.62-6,13.74,0,2,.8,8.55,1.44,13.83.47,3.83.75,6.2.75,6.74Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "545.46px 197.25px 0px",
        }}
        id="elxcd2hc1ni2"
        className="animable"
      />
      <path
        d="M467.9,204.14l.29-56.16-.76-33.45h-7.2l2.83,34.87L458.78,211s-2.85,8.55-2,10.26a2.8,2.8,0,0,0,4.28,1.14c1.43-1.14,4.56-2,6.56-2.85s3.42-.29,2.56-3.14S467.9,204.14,467.9,204.14Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "463.529px 168.752px 0px",
        }}
        id="el2155rxj1nug"
        className="animable"
      />
      <path
        d="M449.09,254.32c.57-1.14,3.13-6.56,5.13-8.84s2.56-3.7,4.84-2.56,2.57,6.55,3.14,12.26,1.71,7.69,1.71,7.69a15.54,15.54,0,0,1,.86,4.85c0,2,.35,8.58.5,12.28h3.8c.09-4.14.27-12.63.27-13.71a8.84,8.84,0,0,0-1.28-3.5,24.87,24.87,0,0,0,.16-4c-.16-1.11-2.55-7.17-2.87-10s-.79-9.4,1.12-8.45,6,12.11,6.53,15.14-.48,5.89,0,7.17a8.51,8.51,0,0,0,1.11,2.07,10.81,10.81,0,0,0-.31,3.34c.16,1.6.63,4.62.63,6.21a56.07,56.07,0,0,0,.78,5.75h2.23c.31-4,1-13,1-13.71,0-1-.32-3.19-.32-3.19a5,5,0,0,0,0-4c-1-2.07-3.19-9.08-4.14-12s-2.87-8.28-1-6.85,6.05,11.16,6.69,12.91.16,4.78,1,5.89l.79,1.12a3.37,3.37,0,0,0,.16,2.55c.64,1.43.8,4.93,1,5.89.12.72,1.05,7.84,1.5,11.32h3.54c-.74-3.8-2.33-12.09-2.33-13.07,0-1.28.31-5.42.31-6.53a8.13,8.13,0,0,0-.95-2.87,3.55,3.55,0,0,0-.48-2.55c-.8-1.27-1.59-2.55-1.59-2.55s-4-8.28-4.46-10,.32-2.87,1.43-1.92,4.46,7.81,5.26,9.56a22.51,22.51,0,0,1,1.11,3.82l.32,1a9.82,9.82,0,0,0,1.12,3.35c1,1.75,2.39,5.25,2.39,5.25s1.91,6.85,2.23,8.29.31,9.24,1.11,7.8.8-9.56.8-9.56-1.28-6.05-1.75-9.24-1.6-9.08-2.23-10.35-2.87-5.42-3.67-6.85-3.5-6.53-3.66-7.17-.8-3-1.91-3.82a5.08,5.08,0,0,0-2.39-1.28c-1-.15-.21-1.23-.66-3.72,0,0-2.57-5.7-6.56-6s-12.83,4.28-12.26,7.7,4.85,4.28,4.85,4.28l-6.28,3.42s-3.42,0-4.27,1.71-7.42,12.26-7.42,14.26S448.52,255.46,449.09,254.32Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "469.825px 250.773px 0px",
        }}
        id="elqlwtv589twb"
        className="animable"
      />
      <path
        d="M552.52,114.53l2.1,11.65s-6.31,34.56-5.21,34,11-17.28,11.52-18.65c.43-1.09,2.08-19.5,2.74-27Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "556.476px 137.358px 0px",
        }}
        id="elw0uk5uh77b"
        className="animable"
      />
      <path
        d="M561.48,144s-10.15,17-11,18.65a35.37,35.37,0,0,0-2.19,7.68c-.27,1.92-5.49,42.24-5.49,42.24l.55,18.11s8-49.65,9.33-54.86,3.84-14.82,4.94-18.38S561.48,144,561.48,144Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "552.14px 187.34px 0px",
        }}
        id="elx7m5fcr1vl"
        className="animable"
      />
      <path
        d="M548.58,162.66s-5.21,34.56-5.76,39a97.91,97.91,0,0,0-.54,14.81c.27,2.2,1.37,19.75.54,20.85a39.42,39.42,0,0,1-2.74,3s1.1,4.39.55,5.76-3,1.65-5.21,1.37-4.67.28-4.39-1.37,2.19-6,1.92-8.23-1.92-1.92.27-5.21,3.84-10.15,3.84-10.15,3.84-58.7,3.84-59.8S547.76,158.27,548.58,162.66Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "539.794px 203.999px 0px",
        }}
        id="eltnd7hcj9nx"
        className="animable"
      />
      <path
        d="M526.91,272.11v6a5.66,5.66,0,0,0,.3,1.86h4.37a19.68,19.68,0,0,1,1.09-6c.55-1.1,2.75,3.84,2.75,4.94a4.26,4.26,0,0,1-.17,1h9c.44-1.55,1.73-7.21.73-11.73-1.1-4.94-2.47-14.27-2.47-14.27l-1.92-4.66-9.88-.82s-6,2.47-6,4.39-1.37,5.21-.55,6.58S526.91,270.74,526.91,272.11Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "534.625px 264.2px 0px",
        }}
        id="elpmvupoat5ir"
        className="animable"
      />
      <path
        d="M477.56,161.08l5.78-13.3c-1.6-11.34-3.46-24-3.46-24l-2.05-9.22h-8l6.38,34.3S476.93,156.15,477.56,161.08Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "476.585px 137.82px 0px",
        }}
        id="eljkr39dj9cbg"
        className="animable"
      />
      <path
        d="M483.43,148.4l-5.22,18c-.13,7.22-3.75,39.78-3.75,39.78s-3.14,11.12-2.85,12.54,4.28,1.43,5.42,2,2.56-4.85,2.56-6,4-42.48,4.28-44.76,1.71-2.28,1.71-4.84C485.58,164,484.59,156.64,483.43,148.4Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "478.586px 184.581px 0px",
        }}
        id="elcxm7vk4to6g"
        className="animable"
      />
      <rect
        x={555.1}
        y={270.71}
        width={15.72}
        height={1}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "562.96px 271.21px 0px",
        }}
        id="elc3zbr3t1j56"
        className="animable"
      />
      <rect
        x={555.1}
        y={266.9}
        width={15.72}
        height={1}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "562.96px 267.4px 0px",
        }}
        id="elmdln00xym2"
        className="animable"
      />
      <rect
        x={555.1}
        y={263.09}
        width={15.72}
        height={1}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "562.96px 263.59px 0px",
        }}
        id="elpjmjiqzvw9"
        className="animable"
      />
      <rect
        x={492.7}
        y={127.34}
        width={15.72}
        height={1}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "500.56px 127.84px 0px",
        }}
        id="eljsz72qv2nz"
        className="animable"
      />
      <rect
        x={492.7}
        y={123.53}
        width={15.72}
        height={1}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "500.56px 124.03px 0px",
        }}
        id="elhlyywdng5ab"
        className="animable"
      />
      <rect
        x={492.7}
        y={119.71}
        width={15.72}
        height={1}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "500.56px 120.21px 0px",
        }}
        id="elfejzhu3ldv"
        className="animable"
      />
    </g>
    <g
      id="freepik--table-2--inject-359"
      style={{
        transformOrigin: "585.47px 408.48px 0px",
      }}
      className="animable"
    >
      <polygon
        points="486.62 381.14 486.62 440.58 495.05 440.58 495.05 398.41 704.5 398.41 704.5 440.58 713.09 440.58 713.09 381.14 486.62 381.14"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "599.855px 410.86px 0px",
        }}
        id="elylfs121f5e"
        className="animable"
      />
      <path
        d="M713.09,441.08H704.5a.5.5,0,0,1-.5-.5V398.91H495.55v41.67a.51.51,0,0,1-.5.5h-8.43a.5.5,0,0,1-.5-.5V381.14a.5.5,0,0,1,.5-.5H713.09a.51.51,0,0,1,.5.5v59.44A.51.51,0,0,1,713.09,441.08Zm-8.09-1h7.59V381.64H487.12v58.44h7.43V398.41a.5.5,0,0,1,.5-.5H704.5a.5.5,0,0,1,.5.5Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "599.855px 410.86px 0px",
        }}
        id="el87l66b1itp"
        className="animable"
      />
      <polygon
        points="484.21 381.14 484.21 440.58 492.64 440.58 492.64 398.41 702.1 398.41 702.1 440.58 710.68 440.58 710.68 381.14 484.21 381.14"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "597.445px 410.86px 0px",
        }}
        id="el2jmzvsdnb0d"
        className="animable"
      />
      <path
        d="M710.68,441.08h-8.59a.51.51,0,0,1-.5-.5V398.91H493.14v41.67a.5.5,0,0,1-.5.5h-8.43a.51.51,0,0,1-.5-.5V381.14a.51.51,0,0,1,.5-.5H710.68a.5.5,0,0,1,.5.5v59.44A.5.5,0,0,1,710.68,441.08Zm-8.09-1h7.59V381.64H484.71v58.44h7.43V398.41a.5.5,0,0,1,.5-.5H702.09a.5.5,0,0,1,.5.5Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "597.445px 410.86px 0px",
        }}
        id="eld3kifskyzhp"
        className="animable"
      />
      <rect
        x={486.62}
        y={381.14}
        width={226.47}
        height={22.57}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "599.855px 392.425px 0px",
        }}
        id="elv6fhxf2nxzd"
        className="animable"
      />
      <path
        d="M713.09,404.21H486.62a.5.5,0,0,1-.5-.5V381.14a.5.5,0,0,1,.5-.5H713.09a.51.51,0,0,1,.5.5v22.57A.5.5,0,0,1,713.09,404.21Zm-226-1H712.59V381.64H487.12Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "599.855px 392.425px 0px",
        }}
        id="el2m74z3xu0jk"
        className="animable"
      />
      <rect
        x={486.62}
        y={381.14}
        width={226.47}
        height={4.36}
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "599.855px 383.32px 0px",
        }}
        id="el1egu2v86gww"
        className="animable"
      />
      <path
        d="M713.09,386H486.62a.5.5,0,0,1-.5-.5v-4.36a.5.5,0,0,1,.5-.5H713.09a.51.51,0,0,1,.5.5v4.36A.51.51,0,0,1,713.09,386Zm-226-1H712.59v-3.36H487.12Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "599.855px 383.32px 0px",
        }}
        id="eld1fh65xief"
        className="animable"
      />
      <rect
        x={483.74}
        y={376.38}
        width={232.24}
        height={6.61}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "599.86px 379.685px 0px",
        }}
        id="el00s4q492t4rso"
        className="animable"
      />
      <path
        d="M716,383.49H483.74a.5.5,0,0,1-.5-.5v-6.61a.5.5,0,0,1,.5-.5H716a.5.5,0,0,1,.5.5V383A.5.5,0,0,1,716,383.49Zm-231.73-1H715.47v-5.61H484.24Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "599.87px 379.685px 0px",
        }}
        id="elobd7w6qlka"
        className="animable"
      />
      <rect
        x={461.94}
        y={402.27}
        width={8.43}
        height={38.31}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "466.155px 421.425px 0px",
        }}
        id="elj0q27ffh4di"
        className="animable"
      />
      <path
        d="M470.37,441.08h-8.43a.51.51,0,0,1-.5-.5V402.27a.5.5,0,0,1,.5-.5h8.43a.5.5,0,0,1,.5.5v38.31A.5.5,0,0,1,470.37,441.08Zm-7.93-1h7.43V402.77h-7.43Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "466.155px 421.425px 0px",
        }}
        id="elb2qy7o3p9ov"
        className="animable"
      />
      <rect
        x={459.22}
        y={402.27}
        width={8.43}
        height={38.31}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "463.435px 421.425px 0px",
        }}
        id="elmp1y0fjbdp"
        className="animable"
      />
      <path
        d="M467.65,441.08h-8.43a.5.5,0,0,1-.5-.5V402.27a.5.5,0,0,1,.5-.5h8.43a.5.5,0,0,1,.5.5v38.31A.5.5,0,0,1,467.65,441.08Zm-7.93-1h7.43V402.77h-7.43Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "463.435px 421.425px 0px",
        }}
        id="elkw6zj2o12g"
        className="animable"
      />
      <rect
        x={675.7}
        y={402.27}
        width={8.59}
        height={38.31}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "679.995px 421.425px 0px",
        }}
        id="elfbxjt5yn9xj"
        className="animable"
      />
      <path
        d="M684.29,441.08H675.7a.51.51,0,0,1-.5-.5V402.27a.5.5,0,0,1,.5-.5h8.59a.5.5,0,0,1,.5.5v38.31A.5.5,0,0,1,684.29,441.08Zm-8.09-1h7.59V402.77H676.2Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "679.995px 421.425px 0px",
        }}
        id="elp3tayaoojbb"
        className="animable"
      />
      <rect
        x={672.98}
        y={402.27}
        width={8.59}
        height={38.31}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "677.275px 421.425px 0px",
        }}
        id="elkjdm3sjmff"
        className="animable"
      />
      <path
        d="M681.57,441.08H673a.5.5,0,0,1-.5-.5V402.27a.5.5,0,0,1,.5-.5h8.59a.5.5,0,0,1,.5.5v38.31A.5.5,0,0,1,681.57,441.08Zm-8.09-1h7.59V402.77h-7.59Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "677.295px 421.425px 0px",
        }}
        id="elhb944u28nwi"
        className="animable"
      />
      <rect
        x={457.82}
        y={381.14}
        width={226.47}
        height={22.57}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "571.055px 392.425px 0px",
        }}
        id="el77bfncrhwt5"
        className="animable"
      />
      <path
        d="M684.29,404.21H457.82a.5.5,0,0,1-.5-.5V381.14a.51.51,0,0,1,.5-.5H684.29a.5.5,0,0,1,.5.5v22.57A.5.5,0,0,1,684.29,404.21Zm-226-1H683.79V381.64H458.32Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "571.055px 392.425px 0px",
        }}
        id="el9hqg2uw8r7b"
        className="animable"
      />
      <rect
        x={457.82}
        y={381.14}
        width={226.47}
        height={4.36}
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "571.055px 383.32px 0px",
        }}
        id="el20hcmwu31nh"
        className="animable"
      />
      <path
        d="M684.29,386H457.82a.51.51,0,0,1-.5-.5v-4.36a.51.51,0,0,1,.5-.5H684.29a.5.5,0,0,1,.5.5v4.36A.5.5,0,0,1,684.29,386Zm-226-1H683.79v-3.36H458.32Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "571.055px 383.32px 0px",
        }}
        id="el4mxu9r8libv"
        className="animable"
      />
      <rect
        x={454.94}
        y={376.38}
        width={232.24}
        height={6.61}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "571.06px 379.685px 0px",
        }}
        id="elvuzd3478i1i"
        className="animable"
      />
      <path
        d="M687.17,383.49H454.94a.5.5,0,0,1-.5-.5v-6.61a.5.5,0,0,1,.5-.5H687.17a.5.5,0,0,1,.5.5V383A.5.5,0,0,1,687.17,383.49Zm-231.73-1H686.67v-5.61H455.44Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "571.055px 379.685px 0px",
        }}
        id="el05ea2xuap0r2"
        className="animable"
      />
    </g>
    <g
      id="freepik--Device--inject-359"
      style={{
        transformOrigin: "587.145px 332.165px 0px",
      }}
      className="animable"
    >
      <rect
        x={587.86}
        y={359}
        width={19.91}
        height={17.83}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "597.815px 367.915px 0px",
        }}
        id="elk7z08oyylj"
        className="animable"
      />
      <path
        d="M607.77,377.33H587.86a.51.51,0,0,1-.5-.5V359a.51.51,0,0,1,.5-.5h19.91a.5.5,0,0,1,.5.5v17.83A.5.5,0,0,1,607.77,377.33Zm-19.41-1h18.91V359.5H588.36Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "597.815px 367.915px 0px",
        }}
        id="elgd1yoghrpk4"
        className="animable"
      />
      <rect
        x={586.47}
        y={359}
        width={19.91}
        height={17.83}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "596.425px 367.915px 0px",
        }}
        id="el8ex1qbjm9ln"
        className="animable"
      />
      <path
        d="M606.38,377.33H586.47a.51.51,0,0,1-.5-.5V359a.51.51,0,0,1,.5-.5h19.91a.5.5,0,0,1,.5.5v17.83A.5.5,0,0,1,606.38,377.33Zm-19.41-1h18.91V359.5H587Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "596.425px 367.915px 0px",
        }}
        id="el27ons0n0qph"
        className="animable"
      />
      <rect
        x={576.75}
        y={374.96}
        width={31.02}
        height={1.86}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "592.26px 375.89px 0px",
        }}
        id="el2jy9taakr82"
        className="animable"
      />
      <path
        d="M607.77,377.33h-31a.5.5,0,0,1-.5-.5V375a.5.5,0,0,1,.5-.5h31a.5.5,0,0,1,.5.5v1.87A.5.5,0,0,1,607.77,377.33Zm-30.52-1h30v-.87h-30Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "592.27px 375.915px 0px",
        }}
        id="ellgepotavxgm"
        className="animable"
      />
      <rect
        x={549.64}
        y={287.53}
        width={97.04}
        height={73.98}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "598.16px 324.52px 0px",
        }}
        id="eljt5viy695z"
        className="animable"
      />
      <path
        d="M646.69,362H549.64a.5.5,0,0,1-.5-.5v-74a.51.51,0,0,1,.5-.5h97.05a.51.51,0,0,1,.5.5v74A.5.5,0,0,1,646.69,362Zm-96.55-1h96.05V288H550.14Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "598.165px 324.5px 0px",
        }}
        id="elvucw5bni8q"
        className="animable"
      />
      <rect
        x={547.03}
        y={287.53}
        width={97.04}
        height={73.98}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "595.55px 324.52px 0px",
        }}
        id="elpsqe41cp0u"
        className="animable"
      />
      <path
        d="M644.08,362H547a.5.5,0,0,1-.5-.5v-74a.51.51,0,0,1,.5-.5h97.05a.51.51,0,0,1,.5.5v74A.5.5,0,0,1,644.08,362Zm-96.55-1h96.05V288H547.53Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "595.525px 324.5px 0px",
        }}
        id="elccxxfjxyp3e"
        className="animable"
      />
      <rect
        x={551.8}
        y={291.17}
        width={87.51}
        height={66.71}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "595.555px 324.525px 0px",
        }}
        id="el0rtcyom52kh"
        className="animable"
      />
      <path
        d="M639.31,358.38H551.8a.5.5,0,0,1-.5-.5V291.17a.5.5,0,0,1,.5-.5h87.51a.5.5,0,0,1,.5.5v66.71A.5.5,0,0,1,639.31,358.38Zm-87-1h86.51V291.67H552.3Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "595.555px 324.525px 0px",
        }}
        id="elfv03y9337vg"
        className="animable"
      />
      <rect
        x={551.8}
        y={298.77}
        width={87.51}
        height={59.11}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "595.555px 328.325px 0px",
        }}
        id="elw3c1r3k5dpj"
        className="animable"
      />
      <path
        d="M639.31,358.38H551.8a.5.5,0,0,1-.5-.5V298.77a.5.5,0,0,1,.5-.5h87.51a.5.5,0,0,1,.5.5v59.11A.5.5,0,0,1,639.31,358.38Zm-87-1h86.51V299.27H552.3Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "595.555px 328.325px 0px",
        }}
        id="ely6ppnx5lc3m"
        className="animable"
      />
      <path
        d="M604.67,353a.5.5,0,0,1-.5-.5V304.68a.5.5,0,1,1,1,0v47.84A.5.5,0,0,1,604.67,353Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "604.67px 328.59px 0px",
        }}
        id="el7y6je3wdw8n"
        className="animable"
      />
      <path
        d="M632.18,305.18H611.45a.5.5,0,0,1,0-1h20.73a.5.5,0,0,1,0,1Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "621.815px 304.68px 0px",
        }}
        id="elqxor6dv5ys"
        className="animable"
      />
      <path
        d="M632.18,309.56H611.45a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.73a.5.5,0,0,1,.5.5A.5.5,0,0,1,632.18,309.56Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "621.815px 309.06px 0px",
        }}
        id="eloapb6n4s1o"
        className="animable"
      />
      <path
        d="M632.18,314H611.45a.5.5,0,0,1,0-1h20.73a.5.5,0,0,1,0,1Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "621.815px 313.5px 0px",
        }}
        id="elrf5ralhli4e"
        className="animable"
      />
      <path
        d="M632.18,318.33H611.45a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.73a.5.5,0,0,1,.5.5A.5.5,0,0,1,632.18,318.33Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "621.815px 317.83px 0px",
        }}
        id="elzynfs3vmmg"
        className="animable"
      />
      <path
        d="M632.18,322.72H611.45a.5.5,0,0,1,0-1h20.73a.5.5,0,0,1,0,1Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "621.815px 322.22px 0px",
        }}
        id="elkafzn2j4quc"
        className="animable"
      />
      <path
        d="M632.18,327.11H611.45a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.73a.5.5,0,0,1,.5.5A.5.5,0,0,1,632.18,327.11Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "621.815px 326.61px 0px",
        }}
        id="elszo3na5i7lq"
        className="animable"
      />
      <path
        d="M632.18,331.49H611.45a.5.5,0,0,1,0-1h20.73a.5.5,0,0,1,0,1Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "621.815px 330.99px 0px",
        }}
        id="ellx6ijszz3f9"
        className="animable"
      />
      <path
        d="M632.18,335.88H611.45a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.73a.5.5,0,0,1,.5.5A.5.5,0,0,1,632.18,335.88Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "621.815px 335.38px 0px",
        }}
        id="elcbtb50xfjdk"
        className="animable"
      />
      <path
        d="M632.18,340.26H611.45a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.73a.5.5,0,0,1,.5.5A.5.5,0,0,1,632.18,340.26Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "621.815px 339.76px 0px",
        }}
        id="elr660vtmhz8"
        className="animable"
      />
      <path
        d="M632.18,344.65H611.45a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.73a.5.5,0,0,1,.5.5A.5.5,0,0,1,632.18,344.65Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "621.815px 344.15px 0px",
        }}
        id="elfg59equreef"
        className="animable"
      />
      <path
        d="M632.18,349H611.45a.5.5,0,0,1-.5-.5.5.5,0,0,1,.5-.5h20.73a.5.5,0,0,1,.5.5A.5.5,0,0,1,632.18,349Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "621.815px 348.5px 0px",
        }}
        id="ely23muy4wft"
        className="animable"
      />
      <rect
        x={554.84}
        y={305.87}
        width={40.67}
        height={27.91}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "575.175px 319.825px 0px",
        }}
        id="elvnv969vcbe"
        className="animable"
      />
      <path
        d="M595.5,334.28H554.84a.5.5,0,0,1-.5-.5V305.87a.5.5,0,0,1,.5-.5H595.5a.5.5,0,0,1,.5.5v27.91A.5.5,0,0,1,595.5,334.28Zm-40.16-1H595V306.37H555.34Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "575.17px 319.825px 0px",
        }}
        id="ela27clgzhtw"
        className="animable"
      />
      <rect
        x={527.6}
        y={373.7}
        width={70.88}
        height={3.13}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "563.04px 375.265px 0px",
        }}
        id="eleruo3lae417"
        className="animable"
      />
      <path
        d="M598.48,377.33H527.6a.51.51,0,0,1-.5-.5V373.7a.5.5,0,0,1,.5-.5h70.88a.5.5,0,0,1,.5.5v3.13A.5.5,0,0,1,598.48,377.33Zm-70.38-1H598V374.2H528.1Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "563.04px 375.265px 0px",
        }}
        id="elf7pideuaiil"
        className="animable"
      />
    </g>
    <g
      id="freepik--Poster--inject-359"
      style={{
        transformOrigin: "292.08px 204.77px 0px",
      }}
      className="animable animator-active"
    >
      <g id="ele8ht6gszrs">
        <g
          style={{
            opacity: 0.3,
            transformOrigin: "292.08px 204.77px 0px",
          }}
          className="animable"
        >
          <path
            d="M215.74,286.12l3.63-.8V305.9c0,2,1.21,4.85,3.23,2.42,0,0,2,2.83,3.23,1.62l2-1.14s2.39,1,3.51.57,3.37-3.51,3.37-3.51.56,1.68,2.66-.84,2.39-5.62,2.95-7.72,2.39-13.61,2.95-15.58,0-12.34,0-12.34l-.42-4.49s9.12-24.84,10.66-30.73,3.23-12.07,3.79-17.12,2.94-15,2.94-15l1-.42s.14,23.71-.42,26.8-4.77,8.84-4.35,16.13-2.11,19.65-2.81,23.85-6,18.53-3.79,42a201.49,201.49,0,0,0,5.52,31.86h28.75c.5-2.6,4.93-25.6,5.16-26.54s4-18.11,4-18.11a2.78,2.78,0,0,1,2,1.49c.49,1.24,6.94,43.14,6.94,43.16h28.18c2.9-9.74,6.54-23.24,6.54-35,0-18.11-3.72-40.43-4.71-44.4a109,109,0,0,1-1.73-11.66s1.48-6,0-11.16-2.48-7.19-3.72-12.89A146.68,146.68,0,0,1,324.47,212v-9.68s4.72,11.41,6.95,19.35,2.23,12.65,4.71,20.09,7.69,21.33,8.68,24.31-1.24,8.18-.25,16.12,2,21.57,3.72,23.56,3.72-.25,3.72-.25.75,4,2.24,4.47,3.47-1,3.47-1a2,2,0,0,0,3,1.49,4.79,4.79,0,0,0,3-2.73s3.72,1.49,3.22-3.47-1.73-11.66-1.73-13.14.25-6.2.25-6.2,2.48,2,4.46,2.23,4,2.23,5.46,0,.25-3-2.48-4.72-3-2.23-5-5.2-.25-3.72-4.47-7.44-6.94-5.46-6.94-8.68,3.22-23.32.25-37.7-4.47-18.11-5-20.34-5-19.1-5-19.1,4-15.62-3-28.77-16.37-12.15-23.56-15.38-12.9-4-13.89-5.95a22.64,22.64,0,0,1-1.49-5.45s6.45-8.93,6.7-11.91l.24-3s4-1.48,5-9.17S312.61,98,312.61,98s.81-11.3-4.44-18.16S290.81,73,285.57,75s-10.5,5.65-11.71,11.71a62.49,62.49,0,0,0-.81,13.32s-4,.81-2.82,5.25a16.46,16.46,0,0,0,3.63,6.86s1.21,5.65,2,8.07,5.25,7.67,5.25,7.67.8,6.06-2,8.08-9.69,3.63-19.38,6.86-18.56,11.7-20.58,22.6a69.14,69.14,0,0,0-.81,19.78l-3.63,23a60.7,60.7,0,0,0-4,19.78c-.4,11.3-2.42,33.9-2.42,33.9s2.42,1.62-3.23,4.44-6.06,4.85-6.86,6.87-1.21,6.05-2.83,7.26-6.86,0-6.05,4S215.74,286.12,215.74,286.12Z"
            id="elwd9hc78gai"
            style={{
              transformOrigin: "292.615px 208.049px 0px",
            }}
            className="animable"
          />
          <path
            d="M330.7,342.71h-29l-.06-.43c-2.22-14.39-6.51-41.89-6.92-43a2,2,0,0,0-1.14-1c-.64,2.94-3.63,16.69-3.86,17.59s-3.33,17-5.15,26.51l-.08.41H255l-.1-.38a201.35,201.35,0,0,1-5.54-31.93,108.09,108.09,0,0,1,3.08-39c.34-1.32.6-2.36.72-3.07s.25-1.46.42-2.42c1-5.31,2.73-15.18,2.38-21.32-.3-5.09,1.61-9.45,3-12.64a18.78,18.78,0,0,0,1.34-3.61c.49-2.7.44-21.89.42-26l-.06,0c-.37,1.56-2.37,10.18-2.87,14.71A121.54,121.54,0,0,1,254.3,233l-.35,1.32C252.46,240,244.05,263,243.31,265l.41,4.38c0,.45.57,10.51,0,12.53-.28,1-.91,4.55-1.52,8s-1.15,6.53-1.43,7.57c-.11.42-.21.88-.32,1.37a14.51,14.51,0,0,1-2.72,6.54c-1,1.18-1.82,1.68-2.55,1.55a1.29,1.29,0,0,1-.49-.22c-.74,1-2.24,2.8-3.2,3.16s-3-.22-3.65-.47l-1.7,1a1.5,1.5,0,0,1-1.14.4,4.32,4.32,0,0,1-2.43-1.65,1.85,1.85,0,0,1-1.94.58c-1.28-.47-1.75-2.51-1.75-3.77v-20l-3,.66c-.43.18-3.48,1.37-5.49.31a3.13,3.13,0,0,1-1.61-2.3,3,3,0,0,1,.35-2.41c.77-1.1,2.34-1.33,3.72-1.54a5.61,5.61,0,0,0,2.17-.59c.95-.71,1.48-2.76,1.93-4.57a23,23,0,0,1,.73-2.48l.18-.45c.75-1.95,1.53-4,6.93-6.67,3-1.52,3.43-2.57,3.46-2.94a.72.72,0,0,0-.3-.64l-.23-.17,0-.29c0-.23,2-22.72,2.42-33.88a62.65,62.65,0,0,1,4.05-19.9l3.61-22.88a70.6,70.6,0,0,1,.83-19.86c1.92-10.37,10.13-19.39,20.91-23,3-1,5.74-1.84,8.15-2.59,5.35-1.66,9.21-2.85,11.1-4.2,2.32-1.66,1.92-6.57,1.83-7.46-.68-.81-4.48-5.41-5.25-7.72s-1.8-7.09-2-8a17.23,17.23,0,0,1-3.65-7,4.79,4.79,0,0,1,.35-3.9,4.58,4.58,0,0,1,2.44-1.85,61.5,61.5,0,0,1,.83-13c1.34-6.67,7.27-10.25,12-12.07,5.37-2.07,17.7-2.16,23.18,5,4.66,6.09,4.66,15.4,4.57,17.89a3.76,3.76,0,0,1,2.8.87c1.27,1.11,1.72,3.17,1.34,6.11-.87,6.76-4,8.92-5,9.44l-.23,2.69c-.24,2.89-5.75,10.71-6.66,12a20.88,20.88,0,0,0,1.41,5.11c.49,1,2.77,1.74,5.67,2.71a83.13,83.13,0,0,1,8,3,41,41,0,0,0,5.58,1.86c6,1.71,12.89,3.64,18.22,13.74,6.62,12.53,3.41,27.45,3.05,29,.44,1.65,4.46,16.86,4.93,19,.13.57.33,1.25.6,2.19.76,2.63,2.17,7.52,4.37,18.16,2.35,11.39.83,26.46.1,33.7-.2,2-.34,3.43-.34,4.1,0,2.48,1.84,4.06,4.9,6.68l1.87,1.62c2.74,2.42,3.08,3.67,3.44,5a7.72,7.72,0,0,0,1.11,2.55l.29.42c1.71,2.59,2,3.05,4.53,4.64l.11.07c1.78,1.14,2.95,1.88,3.19,3a3,3,0,0,1-.68,2.32c-1.26,1.9-2.93,1.25-4.27.73a7.18,7.18,0,0,0-1.66-.51,10.1,10.1,0,0,1-3.95-1.77c-.07,1.44-.2,4.19-.2,5.25,0,.68.3,2.68.65,5s.83,5.53,1.08,8.09c.19,1.84-.16,3.1-1,3.76a2.92,2.92,0,0,1-2.4.37,5.62,5.62,0,0,1-3.07,2.58,2.65,2.65,0,0,1-2.35,0,2.6,2.6,0,0,1-1.07-1.19,4.44,4.44,0,0,1-3.37.7c-1.31-.44-2.06-2.7-2.38-4a3.13,3.13,0,0,1-1.82.64,2.6,2.6,0,0,1-2-1c-1.33-1.52-2.14-8.23-3.14-17.54-.24-2.26-.47-4.43-.7-6.29a42.08,42.08,0,0,1,.2-10.75c.27-2.25.48-4,.07-5.28s-1.38-3.87-2.64-7.33c-2-5.53-4.52-12.4-6-17A75.91,75.91,0,0,1,333,231.11c-.53-2.82-1.08-5.73-2.08-9.3-1.59-5.65-4.47-13.13-6-16.91V212a148.92,148.92,0,0,0,2.22,15,73.25,73.25,0,0,0,2.25,8.1c.45,1.41.92,2.86,1.47,4.77a25,25,0,0,1,0,11.33,108.14,108.14,0,0,0,1.72,11.5c1.1,4.4,4.72,26.89,4.72,44.52,0,11.59-3.51,24.85-6.56,35.11Zm-28.12-1H330c3-10.15,6.42-23.14,6.42-34.47,0-17.55-3.6-39.9-4.69-44.28a107.41,107.41,0,0,1-1.75-11.73v-.08l0-.09c0-.06,1.44-5.89,0-10.9-.53-1.89-1-3.33-1.46-4.73a74.28,74.28,0,0,1-2.26-8.2A144.48,144.48,0,0,1,324,212V199.8l1,2.33c0,.12,4.74,11.53,7,19.41,1,3.61,1.57,6.54,2.11,9.38a75.26,75.26,0,0,0,2.59,10.68c1.52,4.56,4,11.43,6,17,1.26,3.46,2.26,6.2,2.65,7.36.48,1.46.26,3.33,0,5.71a41.06,41.06,0,0,0-.21,10.5c.23,1.87.47,4.05.71,6.32.74,6.94,1.67,15.58,2.89,17a1.63,1.63,0,0,0,1.22.65h0a2.81,2.81,0,0,0,1.74-.9l.68-.75.18,1c.29,1.53,1.07,3.8,1.9,4.08,1,.34,2.52-.55,3-.92l.63-.47.16.78a1.9,1.9,0,0,0,.81,1.17,1.74,1.74,0,0,0,1.49-.05,4.34,4.34,0,0,0,2.68-2.41l.16-.52.5.2a2.29,2.29,0,0,0,1.91-.1c.56-.43.78-1.42.64-2.86-.26-2.53-.71-5.59-1.08-8.05s-.66-4.38-.66-5.14c0-1.49.24-6,.25-6.23l.05-1,.76.6s2.39,1.9,4.21,2.13a7.86,7.86,0,0,1,1.9.57c1.49.57,2.3.82,3.08-.35a2.16,2.16,0,0,0,.53-1.57c-.15-.72-1.18-1.38-2.75-2.37l-.11-.07c-2.68-1.71-3.1-2.33-4.83-4.93l-.28-.43a8.59,8.59,0,0,1-1.24-2.84c-.34-1.22-.62-2.28-3.14-4.5l-1.86-1.61c-3.16-2.71-5.25-4.5-5.25-7.44,0-.72.14-2.18.35-4.2.72-7.19,2.23-22.16-.09-33.4-2.2-10.6-3.6-15.47-4.35-18.08-.28-1-.48-1.65-.61-2.25-.49-2.2-4.91-18.91-5-19.08l0-.13,0-.12c0-.16,3.84-15.6-2.93-28.42-5.14-9.71-11.48-11.5-17.61-13.24a40.39,40.39,0,0,1-5.72-1.91,81.71,81.71,0,0,0-7.88-3c-3.36-1.12-5.57-1.87-6.25-3.21a23.25,23.25,0,0,1-1.54-5.61l0-.2.11-.17c1.78-2.45,6.41-9.32,6.61-11.65l.27-3.29.3-.11s3.7-1.53,4.64-8.78c.33-2.55,0-4.36-1-5.23a3.05,3.05,0,0,0-2.55-.55l-.67.17,0-.69c0-.11.73-11.2-4.34-17.83s-17-6.59-22-4.68c-4.51,1.74-10.15,5.11-11.4,11.34a62.91,62.91,0,0,0-.8,13.19l0,.43-.43.09a3.77,3.77,0,0,0-2.21,1.52,3.9,3.9,0,0,0-.23,3.11,16.37,16.37,0,0,0,3.5,6.64l.11.1,0,.14c0,.06,1.21,5.66,2,8s5.11,7.46,5.16,7.51l.09.11,0,.15c0,.26.81,6.37-2.22,8.54-2,1.44-5.95,2.66-11.38,4.34-2.41.75-5.14,1.6-8.13,2.59-10.29,3.43-18.43,12.36-20.25,22.22a68.82,68.82,0,0,0-.8,19.62v.15l-3.66,23.13a60.84,60.84,0,0,0-4,19.6c-.38,10.54-2.18,31.15-2.4,33.68a1.71,1.71,0,0,1,.49,1.3c-.08,1.24-1.39,2.48-4,3.79-5.05,2.53-5.76,4.36-6.44,6.14l-.18.46a20.5,20.5,0,0,0-.69,2.36c-.5,2-1.06,4.2-2.3,5.12a5.92,5.92,0,0,1-2.62.77c-1.24.19-2.53.39-3,1.13a2.06,2.06,0,0,0-.19,1.64,2.13,2.13,0,0,0,1.09,1.61c1.7.9,4.65-.34,4.68-.36l.09,0,4.24-.95V305.9c0,1.3.51,2.62,1.09,2.83.43.15,1-.39,1.25-.73l.42-.49.37.52c.46.64,1.42,1.66,2.08,1.71a.46.46,0,0,0,.39-.15l.11-.08,2.18-1.26.22.09a6.16,6.16,0,0,0,3.14.56c.72-.27,2.31-2.19,3.14-3.34l.58-.78.3.92h0s.07.18.22.2.56,0,1.59-1.2a13.66,13.66,0,0,0,2.52-6.12c.11-.5.21-1,.33-1.41.26-1,.84-4.3,1.41-7.49.64-3.63,1.24-7.06,1.54-8.09.44-1.55.13-9.32,0-12.19l-.43-4.58,0-.11c.09-.24,9.13-24.88,10.65-30.68l.34-1.32A118.72,118.72,0,0,0,256.76,217c.56-5,2.93-15,3-15.08l.06-.24,1.9-.82v.75c0,1,.13,23.8-.43,26.9a19.63,19.63,0,0,1-1.42,3.83c-1.35,3.09-3.2,7.33-2.92,12.18.36,6.26-1.43,16.21-2.39,21.55-.17,1-.32,1.78-.43,2.42s-.39,1.81-.73,3.14a107,107,0,0,0-3.05,38.68,202,202,0,0,0,5.41,31.41h28c.77-4,4.86-25.24,5.09-26.16s3.93-17.92,4-18.09l.11-.47.47.08a3.23,3.23,0,0,1,2.36,1.8C296.15,300.06,301.37,333.85,302.58,341.71Z"
            style={{
              fill: "rgb(38, 50, 56)",
              transformOrigin: "292.532px 208.075px 0px",
            }}
            id="el9jwlm6crfc"
            className="animable"
          />
          <path
            d="M214.67,286.86l.07-.09c.95.56,2.11,0,2.87-1,1.13-1.59,6.1-7.46,4.75-7,.9-1.36,2-3.17,2-3.17s.91,3.62,0,5.65-2.71,5.66-2,6.79a14.25,14.25,0,0,0-.68,3.84c0,1.37-.52,7-.08,9.29a29.14,29.14,0,0,0-.37,3.82c0,2,.68,4.52,2,1.58s1.13-7.91,1.13-7.91l-.25.07a16.38,16.38,0,0,0,.48-3.69c0-2,.45-6.33.45-6.33l0-.06a2.52,2.52,0,0,0,.72-1.52,38.65,38.65,0,0,1,1.13-5.88,6.43,6.43,0,0,1,2.09-2.69c-.16,1.66-.18,4.11-.28,4.5s-1.47,2.45-1.22,4.28a2.29,2.29,0,0,0,.64,1.31c-.05.06-.11.09-.15.16s-1.11.25-1.23,2.08A12.07,12.07,0,0,1,226,295c-.49,1.1-1.47,2.45,0,3.18a3.09,3.09,0,0,0-1.23,2,14.16,14.16,0,0,0-.22,3.08c-.23,1-.81,3.65-.51,4.64.36,1.22.36,3.43,1.71,2.08s1.59-6.37,1.59-6.37-.2,0-.49.07c.09-.35.2-.77.37-1.29.61-1.84,1-2.94.86-3.55a1.87,1.87,0,0,0-.15-.41,2.83,2.83,0,0,0,.52-1.31c.36-1.84.12-2.45.73-3.43a6.89,6.89,0,0,0,1.47-3.31l.25-1.71c.85-1.47.48-3.06.73-4.78s.73-5.51.73-5.51l-.1-.07a19.15,19.15,0,0,0,2.57.63s0,0,0,0,.49,5.88.74,8.09a6.17,6.17,0,0,0,.45,2,4,4,0,0,0-.57,1.78,34.87,34.87,0,0,1-.37,4.9,3.71,3.71,0,0,0,0,1.52s-.1,0-.13.08-.86,5.75-.13,6.12,1,.73,1.6-.86a23.28,23.28,0,0,0,1.34-3.55l.13-.86-.54-.29c.32-.34.28-1,1-3.14a12.32,12.32,0,0,0,.61-6.24l-.12-1a4.45,4.45,0,0,0-.63,0,13.18,13.18,0,0,0-.23-4.3c-.49-2.52-.66-4-.72-4.55a2,2,0,0,0,.9-.89c1.19-2.17-.22-4.68-.74-6a23,23,0,0,0,1.65-4.13c1.58-4.52,5.19-14.46,6.32-24.86S247.68,229,247.68,229a11.61,11.61,0,0,0,2-6.56,4.54,4.54,0,0,0-1.24-2.83c.52-.34.61-.85,1-1.91.68-1.81,1.13-1.81.91-5s-2.71-2.48-2.71-2.48a60.94,60.94,0,0,1,1.35-15.6c1.81-7.23,4.3-15.37,4.75-19s3.39-15.82,3.39-15.82l5.65-1.13s2.07,2.39,3.33,4.16a5.62,5.62,0,0,0,.8,1.25.42.42,0,0,1,.06.14c-2.3,1.35-3.68,3-3.68,4.89a4,4,0,0,0,.57,2c-2.37,1.39-3.54,3.42-3.21,5.65a5.94,5.94,0,0,0,.8,2.18,5.77,5.77,0,0,0-1.39,4.75,7.79,7.79,0,0,0,1.82,3.74,8.52,8.52,0,0,0-1,7.61,6.94,6.94,0,0,0,1.11,1.82,1.41,1.41,0,0,0-.19.39,25.94,25.94,0,0,0-.64,6.68c-.46,5.15-.31,12.39,3.58,15.15a11,11,0,0,0,6.38,2.2,9.06,9.06,0,0,0,1.87-.19c3.11-.63,6-2.85,8.06-6.25,1.27-2,2.17-5.11,3.22-8.65a60.22,60.22,0,0,1,4-10.88l.1-.13-.22,8.56h-.32a1.34,1.34,0,0,0-1.34,1.34v.06a1.34,1.34,0,0,0,1.34,1.34h.25l-.05,1.92h-.85a1.34,1.34,0,0,0-1.34,1.34v.88a1.34,1.34,0,0,0,1.34,1.34H288l-.09,3.55h-1.33a1.34,1.34,0,0,0-1.34,1.34v.88a1.34,1.34,0,0,0,1.34,1.34h1.24l-.08,3.08h-2.1a1.34,1.34,0,0,0-1.34,1.34v.88a1.33,1.33,0,0,0,1.34,1.33h2l-.06,2.42h-1.95a1.34,1.34,0,0,0-1.34,1.34v.88a1.34,1.34,0,0,0,1.34,1.34h1.86l-.05,2.28h-2.72a1.34,1.34,0,0,0-1.34,1.34v.88c-7.27-5-15.44-6.81-20-3s-5.78,11.56-3.78,14.75,6.58,5,6.77,7.38a34,34,0,0,0,.25,4.72c-1.82-.26-4.15-.26-4.93,1.3-1.34,2.69,0,5.95,0,5.95s-3.26.19-2.87,2.68a8.39,8.39,0,0,0,2.11,4.23s3.64,32,5,44.31a160.08,160.08,0,0,1,.79,23.68h8.56c-1.38-9-5.89-59.32-5.89-61.47v-3.46s3.45-1.34,2.3-3.64-2.69-2.88-1.92-4.41,3.6-2.93,3.6-2.93-2.79,1.8.4,6.18,8,5.39,11,4.39,6.58-6.18,6.58-6.18l1.53-.38,1.53.38s3.59,5.18,6.58,6.18,7.78,0,11-4.39c2-2.76,1.65-4.49,1.1-5.4a6.5,6.5,0,0,1,2.26,2.15c.77,1.53-.76,2.11-1.91,4.41s2.3,3.64,2.3,3.64v3.46c0,2.15-4.52,52.47-5.9,61.47h8.56a160.08,160.08,0,0,1,.79-23.68c1.34-12.28,5-44.31,5-44.31a8.39,8.39,0,0,0,2.11-4.23c.38-2.49-2.88-2.68-2.88-2.68s1.34-3.26,0-5.95c-.69-1.37-2.58-1.54-4.27-1.38a34.29,34.29,0,0,0,.23-4.64c.2-2.39,4.79-4.19,6.78-7.38s.8-11-3.79-14.75-12.68-2-19.91,2.95v-.81A1.34,1.34,0,0,0,301,234h-3.62l0-2.28h2.75a1.33,1.33,0,0,0,1.33-1.34v-.88a1.33,1.33,0,0,0-1.33-1.34h-2.82l0-2.42h2.86a1.32,1.32,0,0,0,1.33-1.33v-.88a1.33,1.33,0,0,0-1.33-1.34h-2.93l-.06-3.08h2.05a1.34,1.34,0,0,0,1.34-1.34v-.88a1.34,1.34,0,0,0-1.34-1.34H297L297,212h1.51a1.34,1.34,0,0,0,1.34-1.34v-.88a1.34,1.34,0,0,0-1.34-1.34H296.9l0-1.92h1a1.34,1.34,0,0,0,1.34-1.34v-.06a1.34,1.34,0,0,0-1.34-1.34h-1l-.13-7.3a68,68,0,0,1,3.41,9.75c1.05,3.54,2,6.6,3.22,8.65,2.09,3.4,5,5.62,8.06,6.25a9.13,9.13,0,0,0,1.87.19,11,11,0,0,0,6.38-2.2c3.89-2.76,4-10,3.59-15.16a26.18,26.18,0,0,0-.65-6.67s0-.08-.05-.12a7.25,7.25,0,0,0,1.32-2.09,8.49,8.49,0,0,0-.89-7.49,7.75,7.75,0,0,0,1.92-3.86,5.74,5.74,0,0,0-1.39-4.75,5.94,5.94,0,0,0,.8-2.18c.35-2.32-.93-4.43-3.5-5.83a4,4,0,0,0,.47-1.85c0-1.72-1.14-3.23-3.07-4.51v-.05c0-.91,4.29-5.88,4.29-5.88l5.66,1.13s2.93,12.21,3.39,15.82,2.93,11.76,4.74,19a61.19,61.19,0,0,1,1.36,15.6s-2.49-.68-2.71,2.48.22,3.17.9,5c.4,1.06.5,1.57,1,1.91a4.48,4.48,0,0,0-1.23,2.83,11.61,11.61,0,0,0,2,6.56s1.13,3.39,2.26,13.79,4.75,20.34,6.33,24.86a22.26,22.26,0,0,0,1.65,4.13c-.53,1.36-1.93,3.87-.75,6a2.14,2.14,0,0,0,.9.89c-.05.52-.23,2-.71,4.55a13.23,13.23,0,0,0-.24,4.3,4.3,4.3,0,0,0-.62,0l-.12,1a12.2,12.2,0,0,0,.61,6.24c.75,2.16.71,2.8,1,3.14l-.53.29.12.86a23.57,23.57,0,0,0,1.35,3.55c.61,1.59.86,1.23,1.59.86s-.12-6.12-.12-6.12-.09,0-.14-.08a3.89,3.89,0,0,0,0-1.52,33.43,33.43,0,0,1-.37-4.9,4,4,0,0,0-.57-1.78,6.45,6.45,0,0,0,.45-2c.24-2.21.73-8.09.73-8.09s0,0,0,0a19.4,19.4,0,0,0,2.56-.63l-.1.07s.49,3.8.74,5.51-.13,3.31.73,4.78l.25,1.71a6.89,6.89,0,0,0,1.46,3.31c.62,1,.37,1.59.74,3.43a2.72,2.72,0,0,0,.52,1.31,1.47,1.47,0,0,0-.15.41c-.13.61.24,1.71.85,3.55.18.52.28.94.37,1.29-.28,0-.49-.07-.49-.07s.25,5,1.59,6.37,1.35-.86,1.72-2.08c.29-1-.28-3.65-.52-4.64a13.56,13.56,0,0,0-.22-3.08,3.06,3.06,0,0,0-1.22-2c1.47-.73.49-2.08,0-3.18a12.28,12.28,0,0,1-.74-4.17c-.12-1.83-1.22-2.08-1.22-2.08s-.1-.1-.15-.16a2.36,2.36,0,0,0,.64-1.31c.24-1.83-1.1-3.79-1.23-4.28s-.11-2.84-.27-4.5a6.51,6.51,0,0,1,2.09,2.69,41.27,41.27,0,0,1,1.13,5.88,2.46,2.46,0,0,0,.71,1.52l0,.06s.46,4.3.46,6.33a16.9,16.9,0,0,0,.47,3.69l-.25-.07s-.22,5,1.13,7.91,2,.45,2-1.58a29.21,29.21,0,0,0-.38-3.82c.44-2.26-.08-7.92-.08-9.29a14.44,14.44,0,0,0-.67-3.84c.67-1.13-1.13-4.75-2-6.79s0-5.65,0-5.65,1.13,1.81,2,3.17c-1.36-.45,3.61,5.42,4.74,7,.76,1.06,1.92,1.6,2.88,1l.06.09c.91,1.13,4.52,1.35,5.65-.46s-4.52-1.35-4.52-1.35c.91-2.71-.9-1.13-2-2.49s-2.49-3.39-2.49-3.39c1.13-1.36-4.07-5.65-4.75-6.1s-4.74-4.3-4.74-4.3c-.68-2.26-3.39-2.26-4.07-5.65s-5.2-36.39-5.2-37.3.45-1.35.68-3.39c.17-1.58-1.16-3.55-3.56-4.46.05-.1.13-.18.17-.28.9-2.26,1.13-3.39,0-6.78s-1.81-6.33-2.26-7.92-7.69-36.39-7.91-40,2.48-7,.9-10.39-4.75-3.62-5.43-3.39-.47-1.21-3.17-1.74a2.23,2.23,0,0,0-3.83-1.38c-1.12-.11-4.25-.33-11.53-.33a36.6,36.6,0,0,0-5.5.41c-1.62-2-4.57-3.57-8.29-4.43a1.32,1.32,0,0,0,.44-1V140a1.34,1.34,0,0,0-1.34-1.34h-2.22l0-1.33h.8a1.34,1.34,0,1,0,0-2.67h-.85l-.07-3.65a8.35,8.35,0,0,0,2.21-.79c2.4-1.31,6.77-4.15,7.42-6.77s.88-9.61.88-9.61a9.25,9.25,0,0,0,3.49-7.21c.22-5,2.63-10.27.44-17.92S296.58,75.57,288.06,78c0,0-6.12.87-9.83,5.25s-4.22,5.3-3.94,9c.22,2.84.88,8.53.44,11.37s1.09,6.33,2.41,7.21a4.73,4.73,0,0,1,1.74,2s-.22,8.31,1.31,10.27a31.37,31.37,0,0,0,7.87,7,9.55,9.55,0,0,0,2,.81l-.09,3.84h-.64a1.34,1.34,0,1,0,0,2.67h.57l0,1.33h-2a1.34,1.34,0,0,0-1.34,1.34v.79a1.25,1.25,0,0,0,.28.77c-4.11.78-7.4,2.41-9.19,4.52a38.54,38.54,0,0,0-4.76-.3c-7.27,0-10.4.22-11.53.33a2.2,2.2,0,0,0-1.6-.68,2.23,2.23,0,0,0-2.22,2c-2.82.51-2.65,2-3.3,1.76s-3.84,0-5.42,3.39,1.13,6.78.9,10.39-7.46,38.43-7.91,40-1.13,4.52-2.26,7.92-.91,4.52,0,6.78c0,.1.11.18.16.28-2.39.91-3.73,2.88-3.55,4.46.22,2,.68,2.49.68,3.39s-4.53,33.91-5.2,37.3-3.39,3.39-4.07,5.65c0,0-4.07,3.85-4.75,4.3s-5.88,4.74-4.75,6.1c0,0-1.35,2-2.48,3.39s-2.94-.22-2,2.49c0,0-5.65-.45-4.52,1.35S213.77,288,214.67,286.86ZM343,226.73c1.13,2.48,2.27,6.78,4.3,18.31a188.22,188.22,0,0,1,2.49,19s-3.39-9.72-5-15.6-2.94-18.31-2.94-18.31Zm-76.18-59.22c-.06.76-.12,1.62-.17,2.51l-.37.1a1.82,1.82,0,0,1-.37-1A2.4,2.4,0,0,1,266.85,167.51Zm-1.28,5.69.13-.06a11.18,11.18,0,0,0,1,.68,14.14,14.14,0,0,0,.26,2.11,12.38,12.38,0,0,0-3.16,1.2l-.24.15a3,3,0,0,1-.27-.85C263,174.86,264.39,173.81,265.57,173.2ZM263.2,181a13.81,13.81,0,0,0,3,2,12.36,12.36,0,0,0-2.59,2.16l-.07.09a4.83,4.83,0,0,1-.85-1.93A3.13,3.13,0,0,1,263.2,181Zm11.05,4.22c-1,.46-2,1-3,1.52a27.21,27.21,0,0,0-3.1,2,13.87,13.87,0,0,1-2.77-1.63l.19-.24a13.08,13.08,0,0,1,3.71-2.65,25.9,25.9,0,0,0,3.15.78C273,185.13,273.63,185.19,274.25,185.24Zm-1-2.74A88,88,0,0,1,286.17,179c0,.47-.07.92-.09,1.36C282.43,181.86,277.72,183.2,273.22,182.5Zm-4.65,9.26a22.63,22.63,0,0,0,3.41.94,17.66,17.66,0,0,0,3.47.33,25.76,25.76,0,0,0,9.25-1.92c-2.47,2.75-6.61,7.28-14.59,6.64a10.21,10.21,0,0,1-5-1.53A12.7,12.7,0,0,1,268.57,191.76Zm-4.69-2.44a16.46,16.46,0,0,0,2.09,1.3,15.84,15.84,0,0,0-2.63,3.42A5.77,5.77,0,0,1,263.88,189.32Zm15,24.21c-1.71,2.78-4,4.57-6.36,5.06a7.83,7.83,0,0,1-6.22-1.58c-1.19-.85-1.89-2.49-2.27-4.47a9.78,9.78,0,0,0,4,2.88,10.47,10.47,0,0,0,3.82.8c4.11,0,6.75-3.13,8.65-6.58A19.44,19.44,0,0,1,278.9,213.53ZM264,205.26a8.25,8.25,0,0,0,4.11,2.18,13.74,13.74,0,0,0,3.09.34,13.5,13.5,0,0,0,8.23-2.57c.23-.18.46-.39.69-.6-2.82,6.38-5.37,10.62-11,8.39C265.59,211.64,264.33,208.39,264,205.26Zm20.66-9.93c-2.28,2.92-4.87,6.23-6.87,7.86s-6,2.44-9.09,1.71a4.89,4.89,0,0,1-3.49-2.38,7.6,7.6,0,0,1-.69-3.15l.06-.35a.48.48,0,0,0,0-.12,13.63,13.63,0,0,0,5.35,1.45c.59.05,1.17.07,1.73.07,7.62,0,12-4.22,14.5-7C285.65,194,285.15,194.66,284.63,195.33Zm-12.14-5.18c-.47-.1-.88-.22-1.31-.33.42-.27.86-.53,1.32-.79A53.47,53.47,0,0,1,286,184.1a4.2,4.2,0,0,0,.29,1.75q.42.65.87,1.29C283.21,189.15,277.67,191.18,272.49,190.15ZM287,148.77c-.44-.22-1-.47-1.6-.72,1.32-.19,2.72-.33,4.2-.41l0,.82A4.62,4.62,0,0,0,287,148.77ZM285.65,155c-.44-.11-.86-.24-1.26-.38l.15-.19.87-.08C285.48,154.56,285.56,154.78,285.65,155Zm1.71,82.58,0,1.49c-.63-.47-1.29-1-2-1.49Zm-1.47,32.52c-1,1.8-2.19,2.19-5.18.2s-2.2-5.78-1-6.38,7.18,1.4,7.18,1.4A12,12,0,0,1,285.89,270.09Zm17.74.2c-3,2-4.18,1.6-5.18-.2a12,12,0,0,1-1-4.78s6-2,7.18-1.4S306.62,268.3,303.63,270.29Zm-3.32-32.72c-1.06.76-2,1.46-2.84,2.1l0-2.1Zm-.5-42.24c-1.08-1.38-2.08-2.66-3-3.74l-.24-.31h0c.45.42.91.86,1.35,1.36l.16.17c2.44,2.71,6.85,7.62,15.05,7.62.56,0,1.14,0,1.74-.07a14.06,14.06,0,0,0,5-1.28l.06.29a7.94,7.94,0,0,1-.69,3.16,4.93,4.93,0,0,1-3.5,2.38c-3.09.73-7,0-9.08-1.71S302.09,198.25,299.81,195.33Zm.08-43.52h0a3.39,3.39,0,0,0-.15-.77c.5-.24,1.14-.52,1.91-.81A2.86,2.86,0,0,0,299.89,151.81Zm.63,2.67q-.56.21-1.17.39l.18-.5Zm-2.39-5.59a4.09,4.09,0,0,0-2.34-.47v-.73c1.4.1,2.73.25,4,.45C299.11,148.41,298.57,148.67,298.13,148.89Zm18.38,40a25.84,25.84,0,0,0-3.3-2.16c-1-.54-2-1-3-1.5a20.44,20.44,0,0,0,2.33-.24,29.19,29.19,0,0,0,3-.74,12.82,12.82,0,0,1,3.63,2.61c.1.11.18.22.27.33A14,14,0,0,1,316.51,188.92Zm2.85,7.48a10.58,10.58,0,0,1-4.69,1.35c-8,.65-12.18-3.95-14.64-6.69L300,191c3.88,1.55,8.49,2.6,13,1.7a24.2,24.2,0,0,0,3-.81A12.35,12.35,0,0,1,319.36,196.4Zm-20.49-16.1c0-.42-.05-.86-.08-1.31a86,86,0,0,1,12.82,3.53C307.15,183.16,302.48,181.84,298.87,180.3Zm.1,3.92a53.11,53.11,0,0,1,13,4.81c.51.29,1,.58,1.46.88-.31.08-.6.17-.92.24-5.19,1-10.73-1-14.66-3,.3-.42.6-.85.87-1.28A3.94,3.94,0,0,0,299,184.22ZM318.11,217a7.81,7.81,0,0,1-6.22,1.58c-2.39-.49-4.65-2.28-6.36-5.06a20.67,20.67,0,0,1-1.66-3.89c1.9,3.45,4.54,6.58,8.66,6.58a10.38,10.38,0,0,0,3.81-.8,9.89,9.89,0,0,0,4.05-2.88C320,214.52,319.31,216.16,318.11,217Zm-2.72-4c-5.68,2.23-8.23-2-11-8.39.23.21.46.42.68.6a13.5,13.5,0,0,0,8.23,2.57,13.76,13.76,0,0,0,3.1-.34,8.34,8.34,0,0,0,4.11-2.18C320.11,208.39,318.85,211.64,315.39,213Zm6-18.89c0,.09-.09.17-.13.26a15,15,0,0,0-2.63-3.56,16.53,16.53,0,0,0,2.3-1.4A5.72,5.72,0,0,1,321.41,194.11Zm.88-10.78a4.88,4.88,0,0,1-.94,2c-.06-.06-.1-.13-.16-.2a12.56,12.56,0,0,0-2.52-2.11,13.69,13.69,0,0,0,3.09-2A3.08,3.08,0,0,1,322.29,183.33Zm-3.66-10,.39-.3.38.18c1.18.61,2.53,1.66,2.3,3.23a3,3,0,0,1-.28.85l-.23-.15a11.92,11.92,0,0,0-2.86-1.12A15.24,15.24,0,0,0,318.63,173.32Zm2.84-24.8c-.9.37-1.49.68-1.49.68a42.54,42.54,0,0,0-6.71-.84C317.18,148.36,319.79,148.44,321.47,148.52Zm-4.4,29.84a10.9,10.9,0,0,1,2.64.94,13.46,13.46,0,0,1-3.93,2.15,60,60,0,0,0-10-3.52c1.49-.11,3.09-.19,4.68-.19C312.07,179.18,315.3,179.75,317.07,178.36Zm-8.89-6.6c.28,1,.53,1.93.76,2.7a64.8,64.8,0,0,1-10.4,1.5c-.09-1.07-.19-2.17-.29-3.27A90.22,90.22,0,0,1,308.18,171.76Zm-1.43-5.2a54.81,54.81,0,0,1-8.94,1.35c-.13-1.38-.24-2.7-.33-3.9a41.43,41.43,0,0,0,6.52-1.13l1.8.28ZM304.16,158a11.56,11.56,0,0,1,.69,1.9c-.35.12-.72.22-1.09.33-2.08-.29-4.24-.49-6.43-.62a3.24,3.24,0,0,1,.21-1.29l.25-.42a22,22,0,0,0,4.8-1.44A21.47,21.47,0,0,1,304.16,158Zm-1.25-11.93a44.71,44.71,0,0,0-7.18-1l0-1.23A19,19,0,0,1,302.91,146.08ZM301,253.74c3.59-2.59,4.79-.59,4.79,1.8a9.69,9.69,0,0,1-.8,4l-12.16,5.18S297.45,256.34,301,253.74Zm-.21-154.2a4.41,4.41,0,1,1,0,8.82c-2.44,0-5.4-3-5.4-5.4S298.39,99.54,300.83,99.54Zm-16.44,8.82a4.41,4.41,0,1,1,0-8.82c2.44,0,5.41,1,5.41,3.42S286.83,108.36,284.39,108.36Zm6.18,1.66a24.25,24.25,0,0,0,1.88-3.53c1-.77,1.65,2.54,2.64,4.52a2.77,2.77,0,0,1-.55,3.53c-.44.55-3.64.44-4.3-.55A3.56,3.56,0,0,1,290.57,110Zm.9,154.69-12.16-5.18a9.69,9.69,0,0,1-.8-4c0-2.39,1.2-4.39,4.79-1.8S291.47,264.71,291.47,264.71Zm-1.74-120.95,0,1.27a44.52,44.52,0,0,0-8,1.05A19.53,19.53,0,0,1,289.73,143.76Zm-4.43,7.08a4.1,4.1,0,0,0-.14.5c-.86-1.27-3.35-1.69-3.35-1.69-.29-.12-.6-.22-.9-.32A25.91,25.91,0,0,1,285.3,150.84ZM281.13,158a14.07,14.07,0,0,1,1.35-1.34,23.26,23.26,0,0,0,4.73,1.33c.07.11.14.22.2.33a3.16,3.16,0,0,1,.21,1.27c-2.32.12-4.61.34-6.81.64l-.44-.13A11.52,11.52,0,0,1,281.13,158Zm-1.61,5,1.05-.16a43.08,43.08,0,0,0,6.89,1.18c-.08,1.19-.19,2.51-.32,3.88a55.71,55.71,0,0,1-8.65-1.22C278.84,165.44,279.19,164.19,279.52,163Zm-2.42,8.73a88.45,88.45,0,0,1,9.6.92c-.1,1.11-.2,2.22-.3,3.3-.87-.05-1.71-.12-2.54-.2l-2.34-.27q-2.85-.37-5.22-.9C276.54,173.81,276.81,172.84,277.1,171.77Zm-2.27,6c1.44,0,2.87.07,4.22.17a59.29,59.29,0,0,0-10,3.5,13.53,13.53,0,0,1-3.81-2.12,11,11,0,0,1,2.89-1C269.9,179.77,273.18,179.2,274.83,177.75ZM272,148.36a42.52,42.52,0,0,0-6.7.84s-.59-.31-1.48-.67C265.48,148.44,268.08,148.37,272,148.36ZM238,245c2-11.53,3.16-15.83,4.29-18.31l1.13,3.39s-1.36,12.43-2.94,18.31-5,15.6-5,15.6A184.65,184.65,0,0,1,238,245Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "292.675px 209.799px 0px",
            }}
            id="el74i0u6zwtvd"
            className="animable"
          />
          <path
            d="M307.44,169.07l0,.11-.66,0Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "307.11px 169.125px 0px",
            }}
            id="elc7rhsoie5h"
            className="animable"
          />
          <path
            d="M303.48,149.65l-.58.12c.38-.12.78-.23,1.21-.35C303.9,149.5,303.68,149.56,303.48,149.65Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "303.505px 149.595px 0px",
            }}
            id="elothp54zk08h"
            className="animable"
          />
          <path
            d="M318.63,169.13a1.36,1.36,0,0,1-.06.29l-.06-.85A1.45,1.45,0,0,1,318.63,169.13Z"
            style={{
              fill: "rgb(255, 255, 255)",
              transformOrigin: "318.57px 168.995px 0px",
            }}
            id="elbh34bocwcpo"
            className="animable"
          />
          <path
            d="M377.08,343.67h-170a.5.5,0,0,1-.5-.5V66.37a.5.5,0,0,1,.5-.5h170a.51.51,0,0,1,.5.5v276.8A.51.51,0,0,1,377.08,343.67Zm-169.47-1h169V66.87h-169Z"
            id="el4g3qmrl9i2s"
            style={{
              transformOrigin: "292.08px 204.77px 0px",
            }}
            className="animable"
          />
          <g id="elal45svqbbuc">
            <rect
              x={231.93}
              y={192.63}
              width={1}
              height={26.46}
              style={{
                transformOrigin: "232.43px 205.86px 0px",
                transform: "rotate(-55.44deg)",
              }}
              className="animable"
            />
          </g>
          <g id="el6nuaxuubf8x">
            <rect
              x={258.32}
              y={121.23}
              width={1}
              height={31.73}
              style={{
                transformOrigin: "258.82px 137.095px 0px",
                transform: "rotate(-15.95deg)",
              }}
              className="animable"
            />
          </g>
          <g id="elgft2n2g079">
            <rect
              x={304.55}
              y={89.61}
              width={25.74}
              height={1}
              style={{
                transformOrigin: "317.42px 90.11px 0px",
                transform: "rotate(-12.0948deg)",
              }}
              className="animable"
            />
          </g>
          <rect
            x={331.45}
            y={123.77}
            width={1}
            height={29.54}
            id="eljvo9yw367qi"
            style={{
              transformOrigin: "331.95px 138.54px 0px",
            }}
            className="animable"
          />
          <rect
            x={234.61}
            y={122.79}
            width={11.14}
            height={1}
            id="elay5b0dpk8ij"
            style={{
              transformOrigin: "240.18px 123.29px 0px",
            }}
            className="animable"
          />
          <rect
            x={336.79}
            y={86.95}
            width={11.62}
            height={1}
            id="elzoo3g5c30to"
            style={{
              transformOrigin: "342.6px 87.45px 0px",
            }}
            className="animable"
          />
          <rect
            x={212.33}
            y={194.46}
            width={11.14}
            height={1}
            id="elb685on6c61t"
            style={{
              transformOrigin: "217.9px 194.96px 0px",
            }}
            className="animable"
          />
          <rect
            x={233.64}
            y={324.74}
            width={36.81}
            height={1}
            id="eldpwswjp885e"
            style={{
              transformOrigin: "252.045px 325.24px 0px",
            }}
            className="animable"
          />
          <rect
            x={219.59}
            y={326.68}
            width={8.23}
            height={1}
            id="elladg7o7uqe"
            style={{
              transformOrigin: "223.705px 327.18px 0px",
            }}
            className="animable"
          />
        </g>
      </g>
    </g>
    <g
      id="freepik--Plant--inject-359"
      style={{
        transformOrigin: "78.2318px 335.613px 0px",
      }}
      className="animable"
    >
      <rect
        x={75.4}
        y={290.62}
        width={4.63}
        height={149.78}
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "77.715px 365.51px 0px",
        }}
        id="eltkhepr6t83f"
        className="animable"
      />
      <path
        d="M77,297.82s4.46-16.47,9.57-27.5,29.06-23.3,31.16-18.51.95,13.35-5.72,25.86S77,297.82,77,297.82Z"
        style={{
          fill: "rgb(97, 185, 255)",
          transformOrigin: "97.8409px 274.282px 0px",
        }}
        id="el2649tgkxc17"
        className="animable"
      />
      <path
        d="M77.9,290s-6.74-15.83-9.52-27.53,9.09-34.23,13.82-31.4,9.22,10.43,11.65,24.16S77.9,290,77.9,290Z"
        style={{
          fill: "rgb(97, 185, 255)",
          transformOrigin: "81.0174px 260.413px 0px",
        }}
        id="eluxv1o7z57rd"
        className="animable"
      />
      <path
        d="M78.39,298s-2.27-16.84-5.88-28.35S46.74,243.33,44,247.85,41.31,261,46.28,274.14,78.39,298,78.39,298Z"
        style={{
          fill: "rgb(97, 185, 255)",
          transformOrigin: "60.2859px 272.508px 0px",
        }}
        id="elwf8uf8y7jr"
        className="animable"
      />
      <path
        d="M77.44,319.59s8.83-14.95,16.79-24.48,34.52-16,35.24-10.9-2.72,13.14-12.6,23.76S77.44,319.59,77.44,319.59Z"
        style={{
          fill: "rgb(97, 185, 255)",
          transformOrigin: "103.501px 301.005px 0px",
        }}
        id="elgk9s2joz12n"
        className="animable"
      />
      <path
        d="M79.05,319.59s-8.83-14.95-16.79-24.48-34.51-16-35.23-10.9,2.72,13.14,12.6,23.76S79.05,319.59,79.05,319.59Z"
        style={{
          fill: "rgb(97, 185, 255)",
          transformOrigin: "52.994px 301.005px 0px",
        }}
        id="elg8fnpo7rylm"
        className="animable"
      />
      <path
        d="M77.44,349.17s8.83-14.95,16.79-24.48,34.52-16,35.24-10.9-2.72,13.15-12.6,23.76S77.44,349.17,77.44,349.17Z"
        style={{
          fill: "rgb(97, 185, 255)",
          transformOrigin: "103.501px 330.585px 0px",
        }}
        id="elf7zok30yu"
        className="animable"
      />
      <path
        d="M79.05,349.17s-8.83-14.95-16.79-24.48-34.51-16-35.23-10.9,2.72,13.15,12.6,23.76S79.05,349.17,79.05,349.17Z"
        style={{
          fill: "rgb(97, 185, 255)",
          transformOrigin: "52.994px 330.585px 0px",
        }}
        id="eloaadtf9jo6"
        className="animable"
      />
      <path
        d="M77.44,378.76s8.83-15,16.79-24.48,34.52-16,35.24-10.91-2.72,13.15-12.6,23.76S77.44,378.76,77.44,378.76Z"
        style={{
          fill: "rgb(97, 185, 255)",
          transformOrigin: "103.501px 360.176px 0px",
        }}
        id="el189lq868229"
        className="animable"
      />
      <path
        d="M79.05,378.76s-8.83-15-16.79-24.48-34.51-16-35.23-10.91,2.72,13.15,12.6,23.76S79.05,378.76,79.05,378.76Z"
        style={{
          fill: "rgb(97, 185, 255)",
          transformOrigin: "52.994px 360.176px 0px",
        }}
        id="el37fqm2dygzx"
        className="animable"
      />
      <path
        d="M77.44,408.34s8.83-14.95,16.79-24.48,34.52-16,35.24-10.9-2.72,13.14-12.6,23.76S77.44,408.34,77.44,408.34Z"
        style={{
          fill: "rgb(97, 185, 255)",
          transformOrigin: "103.501px 389.755px 0px",
        }}
        id="elwyhacckelfn"
        className="animable"
      />
      <path
        d="M79.05,408.34s-8.83-14.95-16.79-24.48S27.75,367.85,27,373s2.72,13.14,12.6,23.76S79.05,408.34,79.05,408.34Z"
        style={{
          fill: "rgb(97, 185, 255)",
          transformOrigin: "52.9758px 389.761px 0px",
        }}
        id="el7f0my9kw89j"
        className="animable"
      />
      <path
        d="M77.44,431.76s8.83-14.95,16.79-24.48,34.52-16,35.24-10.9-2.72,13.14-12.6,23.76S77.44,431.76,77.44,431.76Z"
        style={{
          fill: "rgb(97, 185, 255)",
          transformOrigin: "103.501px 413.175px 0px",
        }}
        id="elkm6gxaa44gn"
        className="animable"
      />
      <path
        d="M79.05,431.76s-8.83-14.95-16.79-24.48-34.51-16-35.23-10.9,2.72,13.14,12.6,23.76S79.05,431.76,79.05,431.76Z"
        style={{
          fill: "rgb(97, 185, 255)",
          transformOrigin: "52.994px 413.175px 0px",
        }}
        id="ell6j3rppbcyj"
        className="animable"
      />
      <path
        d="M79.27,318.33l-.43-.91c.27-.12,26.29-12.28,36.65-24l.75.66C105.74,306,79.53,318.2,79.27,318.33Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "97.54px 305.875px 0px",
        }}
        id="el5eial5vfx9o"
        className="animable"
      />
      <path
        d="M75.68,317.79a208.34,208.34,0,0,1-28.62-19.24l.64-.77c12.65,10.48,28.3,19.05,28.45,19.14Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "61.605px 307.785px 0px",
        }}
        id="elbg1fzr64fj"
        className="animable"
      />
      <path
        d="M76.62,298.11c-.16-.22-16.3-22.85-20.54-30.3l.86-.5c4.22,7.41,20.33,30,20.49,30.22Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "66.755px 282.71px 0px",
        }}
        id="elj3giuw1fwzj"
        className="animable"
      />
      <g id="elp4d0haifn3r">
        <rect
          x={71.49}
          y={282.53}
          width={39.29}
          height={1}
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "91.135px 283.03px 0px",
            transform: "rotate(-49.56deg)",
          }}
          className="animable"
        />
      </g>
      <polygon
        points="79.14 296.58 70.87 265.35 71.83 265.1 78.4 289.89 79.98 249.9 80.98 249.94 79.14 296.58"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "75.925px 273.24px 0px",
        }}
        id="el0k6vrl9h9wgp"
        className="animable"
      />
      <path
        d="M77.44,349.76l-.27-.16c-.24-.16-24.21-15.33-35.51-23.81l.6-.8c10.63,8,32.54,21.91,35.19,23.59,2.8-1.71,27-16.64,34.92-25.08l.72.68c-8.51,9-35.12,25.26-35.39,25.42Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "77.375px 336.63px 0px",
        }}
        id="eljzkq105t17i"
        className="animable"
      />
      <path
        d="M77.51,379.33l-.27-.11c-18-7.79-37.71-25.53-37.9-25.71l.67-.74c.19.18,19.56,17.63,37.37,25.41,2.21-1.63,19.64-14.45,34.24-23.13l.51.86c-15.49,9.21-34.2,23.11-34.39,23.25Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "75.735px 366.05px 0px",
        }}
        id="elapzcqow60c"
        className="animable"
      />
      <path
        d="M77.38,408.91l-.23-.16S62.5,398.42,45.66,386.49l.58-.82c15.61,11.06,29.34,20.75,31.26,22.1A118.68,118.68,0,0,0,111,384.17l.71.71a118.67,118.67,0,0,1-34,23.92Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "78.685px 396.54px 0px",
        }}
        id="elrarurinxryl"
        className="animable"
      />
      <path
        d="M77.29,432.24c-14.1-4.62-34.87-21.22-35.08-21.39l.63-.78c.21.17,20.84,16.66,34.76,21.22Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "59.905px 421.155px 0px",
        }}
        id="el97138yxxz3h"
        className="animable"
      />
      <path
        d="M79.29,432.2l-.47-.88c.17-.09,17.8-9.73,30.75-19.95l.62.78C97.18,422.43,79.47,432.1,79.29,432.2Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "94.505px 421.785px 0px",
        }}
        id="elf0k37s8pfkf"
        className="animable"
      />
    </g>
    <g
      id="freepik--Characters--inject-359"
      style={{
        transformOrigin: "294.018px 283.213px 0px",
      }}
      className="animable"
    >
      <path
        d="M152.38,228.13s8.11.44,9.44.8,7.37.76,7.37.76-7.73,7.35-8.34,7.59-1.57.12-4-1.45S152.38,228.13,152.38,228.13Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "160.785px 232.753px 0px",
        }}
        id="ela18ozq6dd9"
        className="animable"
      />
      <path
        d="M160.33,237.87c-.87,0-2-.51-3.74-1.62-2.54-1.65-4.6-7.7-4.69-8a.51.51,0,0,1,.5-.66c.34,0,8.18.45,9.55.82a71,71,0,0,0,7.27.75.49.49,0,0,1,.31.86c-2.34,2.23-7.87,7.43-8.49,7.68A1.83,1.83,0,0,1,160.33,237.87Zm-7.23-9.2c.62,1.62,2.25,5.58,4,6.74s3,1.63,3.53,1.4,4.47-4,7.36-6.7a56.06,56.06,0,0,1-6.33-.7C160.74,229.16,155.72,228.82,153.1,228.67Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "160.788px 232.73px 0px",
        }}
        id="elpz7ndfaa99f"
        className="animable"
      />
      <polygon
        points="244.46 440.42 269.19 440.42 256.51 388.45 251.8 352.28 233.85 352.14 235.85 407.06 244.46 440.42"
        style={{
          fill: "rgb(227, 227, 227)",
          transformOrigin: "251.52px 396.28px 0px",
        }}
        id="el3w7m40fbf8e"
        className="animable"
      />
      <path
        d="M269.83,440.92H244.07l-8.72-33.84-2-55.45,18.91.15,4.76,36.6Zm-25-1h23.71L256,388.57l-4.66-35.79-17-.14,2,54.35Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "251.59px 396.275px 0px",
        }}
        id="elltfbvtm40ym"
        className="animable"
      />
      <path
        d="M243.7,289.35l8.1,62.93H237.47S239.65,287.48,243.7,289.35Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "244.635px 320.795px 0px",
        }}
        id="elx0rmcfkufa"
        className="animable"
      />
      <path
        d="M252.37,352.78H237l0-.52c.21-6.22,2.16-60.89,6.07-63.3a.88.88,0,0,1,.87-.06l.25.11,0,.28Zm-14.38-1h13.24l-7.94-61.69C241.09,293.46,239,323.65,238,351.78Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "244.685px 320.796px 0px",
        }}
        id="elc60rnzh8f5n"
        className="animable"
      />
      <path
        d="M125.55,397l5.39,43.41H251.12L240.5,374.13l1.32-47.62s2.63-40.24,1.84-46.29-2.25-9.45-4.21-11.32c-14.16-13.5-31.56-21.55-33.53-24.72s-8-5.26-8-5.26L174,238.65l-17.34-4.56-4.23-6s-6.84,8.94-7.11,9.73-26.3,29.73-27.62,37.62-.52,33.15,0,50.51S125.55,397,125.55,397Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "184.05px 334.25px 0px",
        }}
        id="elwhokhwrv9aa"
        className="animable"
      />
      <path
        d="M251.12,440.92H130.94a.51.51,0,0,1-.5-.44l-5.39-43.4c-.1-.74-7.38-53.92-7.9-71.08l0-.76c-.54-17.73-1.27-42,0-49.84,1-6.33,16.87-25,24.47-33.92,1.64-1.92,3.05-3.59,3.19-3.83.25-.75,5.54-7.71,7.16-9.82a.47.47,0,0,1,.41-.2.48.48,0,0,1,.39.21l4.14,5.81,17.09,4.5,23.88.27.16,0c.25.09,6.24,2.2,8.29,5.48.72,1.15,4,3.23,8.19,5.87,6.63,4.19,16.64,10.52,25.26,18.75,2.22,2.12,3.61,5.81,4.36,11.61.79,6-1.73,44.75-1.83,46.4L241,374.14l10.61,66.2a.5.5,0,0,1-.49.58Zm-119.74-1H250.53L240,374.21l1.31-47.71c0-.42,2.62-40.29,1.84-46.22-.71-5.49-2-9.09-4.06-11-8.55-8.17-18.12-14.21-25.1-18.63-4.62-2.92-7.67-4.85-8.51-6.19-1.75-2.79-7-4.78-7.69-5l-23.86-.26h-.12l-17.33-4.57a.43.43,0,0,1-.28-.19L152.36,229c-2.59,3.41-6.38,8.47-6.61,9.06-.08.23-.42.65-3.36,4.1-6.95,8.19-23.23,27.38-24.24,33.43-1.29,7.73-.56,32,0,49.65l0,.76c.52,17.14,7.82,70.44,7.89,71h0Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "184.031px 334.275px 0px",
        }}
        id="elkkmozpoojq"
        className="animable"
      />
      <g id="elb6k9ijzvuju">
        <rect
          x={128.6}
          y={411.88}
          width={59.31}
          height={1}
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "158.255px 412.38px 0px",
            transform: "rotate(-37.6736deg)",
          }}
          className="animable"
        />
      </g>
      <g id="eln1usl1gb6">
        <rect
          x={149.44}
          y={402.88}
          width={28.49}
          height={1}
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "163.685px 403.38px 0px",
            transform: "rotate(-37.86deg)",
          }}
          className="animable"
        />
      </g>
      <path
        d="M165,206.72l1.17,21.74-9.52,5.63s12.43,9.71,17.86,17.47,18.83,23.1,25.62,22.52,8.15-15.92,7.18-21.16-1.35-8.74-1.35-8.74l-.78-2.71s-11.26-2.53-16.31-6.41-21-28.53-21.93-29.11S165,206.72,165,206.72Z"
        style={{
          fill: "rgb(227, 227, 227)",
          transformOrigin: "182.12px 239.951px 0px",
        }}
        id="elgwm0ewzskhf"
        className="animable"
      />
      <path
        d="M199.72,274.59c-7.27,0-20.59-15.5-25.66-22.74-5.33-7.62-17.63-17.27-17.75-17.36l-.58-.46,9.88-5.84-1.16-21.61.1-.15c.46-.64,1.53-1.56,2.61-.91.37.22,1.35,1.6,5.05,6.94,5.42,7.83,13.61,19.65,16.93,22.21,4.9,3.77,16,6.28,16.11,6.31l.29.06.86,3c0,.11.41,3.62,1.37,8.78.74,4,.17,14.4-3.51,19.23a5.77,5.77,0,0,1-4.12,2.51A3,3,0,0,1,199.72,274.59Zm-42.23-40.44c2.51,2,12.64,10.34,17.39,17.12,5.63,8,18.8,22.86,25.17,22.31a4.85,4.85,0,0,0,3.42-2.13c3.36-4.41,4.05-14.44,3.31-18.44-1-5.2-1.36-8.74-1.36-8.77l-.68-2.35c-1.84-.43-11.53-2.83-16.21-6.43-3.45-2.65-11.69-14.55-17.14-22.43-2.27-3.28-4.42-6.37-4.78-6.67s-.92.28-1.14.53l1.17,21.85Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "181.891px 239.944px 0px",
        }}
        id="elz06v9t768qf"
        className="animable"
      />
      <rect
        x={165.63}
        y={228.46}
        width={1}
        height={7.96}
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "166.13px 232.44px 0px",
        }}
        id="elk94mfci5a8"
        className="animable"
      />
      <path
        d="M204.33,262.7c-1.5-2.36-1.83-8.41-1.83-9.78,0-1.8,2.65-8.2,2.95-8.93l.93.39c-.8,1.91-2.88,7.19-2.88,8.54,0,1.77.4,7.24,1.67,9.24Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "204.44px 253.345px 0px",
        }}
        id="elndkly95ryqj"
        className="animable"
      />
      <path
        d="M224.16,179.36s1.36,11.06,1.17,13.58-1.75,12-2.14,14.95-.58,7.76-1.75,11.64S213.49,236,212.51,238a11.52,11.52,0,0,1-6.59,6.21c-3.89,1.36-12-1-14.56-1.94s-16.5-14.36-19.61-17.66-6.21-15.14-6.21-15.14a24.35,24.35,0,0,1-7.37-6.4c-3.5-4.47-5-10.29-4.27-13.4s1.46-5.8,3.74-6.2a14.09,14.09,0,0,1,6.16.57c1,.39-3.5-16.11-3.5-16.11s14.56-9.31,30.28-9.51S222.8,171.79,224.16,179.36Z"
        style={{
          fill: "rgb(227, 227, 227)",
          transformOrigin: "189.534px 201.52px 0px",
        }}
        id="el3n2qo857n0c"
        className="animable"
      />
      <path
        d="M202.92,245.1a40.24,40.24,0,0,1-11.74-2.39c-2.69-1-16.75-14.56-19.79-17.79s-5.82-13.47-6.27-15.14a25.17,25.17,0,0,1-7.35-6.44c-3.7-4.74-5.13-10.75-4.36-13.82s1.53-6.11,4.14-6.57a14.7,14.7,0,0,1,5.88.42c-.17-1.94-1.9-9-3.61-15.34l-.1-.35.31-.2c.15-.09,14.86-9.39,30.55-9.59h.33c15.47,0,32.28,13.25,33.74,21.38v0c.05.46,1.36,11.15,1.16,13.69-.12,1.66-.8,6.12-1.41,10.07-.31,2-.59,3.88-.72,4.9-.11.77-.2,1.67-.29,2.66a49.65,49.65,0,0,1-1.48,9.07c-1,3.21-5.64,12.16-7.89,16.47-.51,1-.89,1.69-1.07,2a12.05,12.05,0,0,1-6.88,6.46A9.81,9.81,0,0,1,202.92,245.1Zm-43.6-61.29a9.06,9.06,0,0,0-1.59.13c-2,.34-2.61,2.88-3.35,5.82s.66,8.47,4.18,13a24.15,24.15,0,0,0,7.21,6.26l.2.11.06.21c0,.12,3.11,11.76,6.09,14.93,3.32,3.53,17.06,16.63,19.42,17.54,2.51,1,10.54,3.22,14.21,1.93a11,11,0,0,0,6.32-6c.18-.36.56-1.09,1.07-2.07,2.24-4.27,6.89-13.17,7.82-16.29a47.72,47.72,0,0,0,1.44-8.88c.1-1,.19-1.91.29-2.69.14-1,.42-2.86.74-4.92.56-3.73,1.27-8.38,1.4-10,.18-2.4-1.11-13-1.16-13.47-1.25-6.84-17.12-20.54-32.75-20.54h-.33c-14.15.18-27.52,7.92-29.71,9.24,4.18,15.48,3.58,16,3.32,16.25l-.23.2-.36-.1A13.66,13.66,0,0,0,159.32,183.81Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "189.519px 201.495px 0px",
        }}
        id="elhrn4mx94795"
        className="animable"
      />
      <path
        d="M164,190.58s-.53,6.6,1.32,6.6a3.76,3.76,0,0,0,2.91-1.85l1-3.7,8.19-5-.79-16.11,14.79,5.28,7.93,1.06s-14,3.43-11.89,4.49A36,36,0,0,0,202.82,184c7.13-.26,14.79-4,14.79-4s-1.85,4.49,0,4,9.51-4.23,12.95-8.45,0-10.84-3.44-16.12-12.42-19.55-21.66-22.46-24.57-1.32-29.59,1.59S155,162,154.47,166s3.17,17.43,3.17,17.43S164.77,188.2,164,190.58Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "193.201px 166.303px 0px",
        }}
        id="el15ilg3wqdln"
        className="animable"
      />
      <path
        d="M165.3,197.68a1.29,1.29,0,0,1-1-.43c-1.26-1.37-.91-6.17-.87-6.71l0-.12c.46-1.39-3.32-4.67-6.15-6.56l-.15-.11-.05-.18C157,183,153.44,170,154,165.94c.56-4.19,16.74-25,21.65-27.84,5.4-3.13,20.91-4.48,30-1.63s17.82,16.32,21.55,22.08l.38.58c3.51,5.4,7.07,12.18,3.4,16.7-3.53,4.35-11.31,8.09-13.19,8.62a1.06,1.06,0,0,1-1.15-.25c-.56-.63-.25-2.09.13-3.25-2.39,1-8.26,3.31-13.9,3.52-7,.26-13.11-1.47-15.56-2.69a.77.77,0,0,1-.49-.79c.11-1,3.45-2.3,10-4l-5.45-.74-14.09-5,.77,15.66L169.69,192l-1.05,3.62A4.21,4.21,0,0,1,165.3,197.68Zm-.83-7c-.14,1.89-.1,5.12.62,5.9a.26.26,0,0,0,.21.11,3.18,3.18,0,0,0,2.44-1.55l1.1-3.82,8.1-5-.82-16.57,15.45,5.52,10.5,1.4-2.57.63c-4.86,1.2-10.32,2.86-11.54,3.68a36.54,36.54,0,0,0,14.84,2.47c6.94-.26,14.52-3.88,14.59-3.91l1.18-.57-.5,1.21c-.59,1.44-.94,3-.73,3.32,0,0,0,0,.13,0,2-.57,9.46-4.3,12.7-8.29s-.14-10.41-3.47-15.53l-.38-.58c-3.67-5.66-12.26-18.92-21-21.67-9.33-2.93-24.56-1.14-29.19,1.54-5.09,2.95-20.69,23.62-21.16,27.11s2.68,15.46,3.11,17.06C159.59,184.16,165.2,188.15,164.47,190.67Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "193.234px 166.294px 0px",
        }}
        id="el9szi3g2zs5i"
        className="animable"
      />
      <path
        d="M207.76,226.06h-.51a11.73,11.73,0,0,1-5.9-1.84l.59-.81a11,11,0,0,0,5.36,1.65,5.44,5.44,0,0,0,4.19-1.25A1.47,1.47,0,0,0,212,223c0-.55-1-10.14-1.74-16.45v-.07l2-9.59,1,.2-1.93,9.43c.22,1.94,1.74,15.71,1.74,16.48a2.3,2.3,0,0,1-.83,1.5A6.34,6.34,0,0,1,207.76,226.06Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "207.305px 211.479px 0px",
        }}
        id="elx9xwv3dvkio"
        className="animable"
      />
      <path
        d="M214.44,196.71l-.36-.93c.26-.1,6.3-2.41,9.21-.33l-.58.81C220.24,194.5,214.5,196.69,214.44,196.71Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "218.685px 195.647px 0px",
        }}
        id="ela6wai1796cp"
        className="animable"
      />
      <path
        d="M201.63,197.67c-.07,0-7.45-3.36-14.13-.2l-.43-.9c7.12-3.37,14.66,0,15,.19Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "194.57px 196.375px 0px",
        }}
        id="el260ea60lyd4"
        className="animable"
      />
      <path
        d="M204.19,232a17.55,17.55,0,0,1-5-.57,33.35,33.35,0,0,1-6.33-3.16l.55-.84a33,33,0,0,0,6.09,3c2.76.92,8.87.36,9.39.2l.32.94A26.65,26.65,0,0,1,204.19,232Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "201.035px 229.719px 0px",
        }}
        id="elx92h6wpbw2c"
        className="animable"
      />
      <ellipse
        cx={194.66}
        cy={205.27}
        rx={1.94}
        ry={2.81}
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "194.66px 205.27px 0px",
        }}
        id="ellvbhan8t6q"
        className="animable"
      />
      <path
        d="M218.53,205c0,1.55-.87,2.81-1.94,2.81s-1.94-1.26-1.94-2.81.87-2.82,1.94-2.82S218.53,203.42,218.53,205Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "216.59px 204.995px 0px",
        }}
        id="eloeuvx137j3"
        className="animable"
      />
      <path
        d="M309.79,326.78s-33.93-5.36-37.51-6.63-12-6.38-12-6.38-18.37-20.67-19.9-21.69-13.78,4.08-15.57,5.1-8.16,6.13-8.42,7.4,1.54,4.85,1.54,4.85,17.35,15.57,19.39,16.33,21.18,6.12,21.18,6.12,46.43,24.24,48.73,26,12.76,5.36,16.59,5.36,8.16-3.06,8.16-3.06l-4.85-29.09Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "274.172px 327.593px 0px",
        }}
        id="elyuyfnx04axo"
        className="animable"
      />
      <path
        d="M323.83,363.77c-4,0-14.48-3.58-16.9-5.46-1.78-1.39-32.55-17.57-48.61-26-1.31-.37-19.16-5.37-21.17-6.12S219.38,311.4,217.6,309.8l-.11-.15c-.31-.62-1.85-3.79-1.58-5.16.33-1.62,7.23-6.92,8.67-7.74,1-.59,14.14-6.39,16.09-5.09,1.52,1,17.83,19.35,19.94,21.72.79.47,8.52,5.11,11.84,6.3,3.49,1.24,37.08,6.55,37.42,6.61h0l17.67,4.41,5,29.72-.26.19C332.1,360.74,327.77,363.77,323.83,363.77ZM218.34,309.12c6.95,6.23,17.73,15.64,19.16,16.17,2,.75,20.95,6.06,21.14,6.11l.1,0c1.89,1,46.5,24.28,48.81,26.08s12.63,5.25,16.28,5.25c3.11,0,6.64-2.16,7.61-2.8l-4.74-28.45-17-4.25c-1.67-.26-34-5.38-37.57-6.65s-11.74-6.21-12.09-6.42l-.11-.1c-7.37-8.29-18.72-20.88-19.81-21.6s-12.64,3.75-15,5.12c-1.94,1.11-8,6.09-8.18,7.06C216.74,305.47,217.68,307.79,218.34,309.12Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "274.209px 327.62px 0px",
        }}
        id="elyj5ksdvlfx8"
        className="animable"
      />
      <polygon
        points="223.99 300.08 195.93 335.01 201.38 348.74 227.83 353.99 245.6 314.21 232.88 301.49 223.99 300.08"
        style={{
          fill: "rgb(97, 185, 255)",
          transformOrigin: "220.765px 327.035px 0px",
        }}
        id="elnf11puk5jtg"
        className="animable"
      />
      <path
        d="M228.12,354.55,201,349.17l-5.66-14.25,28.43-35.38,9.33,1.48,13.07,13.08Zm-26.38-6.25,25.8,5.12L245,314.32,232.64,302l-8.44-1.34-27.7,34.47Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "220.755px 327.045px 0px",
        }}
        id="ell9o5ibg15t"
        className="animable"
      />
      <path
        d="M314.37,332.8c5.07,3.09,10.15,5.74,10.15,5.74l5.74,67.76.43,34.12H470.9c-2.12-6.26-12.07-35.6-14.83-40.52-3.09-5.52-10.37-37.52-10.37-37.52l3.75-50.33s6.12-53.47,6.12-54.36-.94-8.93-.94-8.93-50.22-29.19-56.4-30.08-9.7,1.77-12.35,2-22.51,1.55-27.81,3.76c-3.8,1.58-22.6,9.53-32.92,13.89a12.11,12.11,0,0,0-7.36,10.26l-5.19,69.21s-4.41,1.1-4.41,2.21a47.77,47.77,0,0,1-1.11,5.52A21.13,21.13,0,0,0,314.37,332.8Z"
        style={{
          fill: "rgb(97, 185, 255)",
          transformOrigin: "388.99px 329.459px 0px",
        }}
        id="elzcbin8xlttk"
        className="animable"
      />
      <path
        d="M471.59,440.92H330.19l-.43-34.62-5.71-67.45c-1.08-.56-5.54-2.94-9.94-5.62a21.47,21.47,0,0,1-7.47-7.48l-.09-.17.05-.19a45.16,45.16,0,0,0,1.09-5.39c0-1.22,2.63-2.13,4.44-2.6l5.16-68.86A12.55,12.55,0,0,1,325,237.86c13.08-5.53,29.41-12.44,32.92-13.9,4.87-2,21.37-3.28,26.79-3.69l1.17-.09a12.85,12.85,0,0,0,2.79-.76,19.28,19.28,0,0,1,9.67-1.23c6.2.89,54.53,28.95,56.58,30.14l.22.13,0,.25c0,.33.94,8.08.94,9s-5.5,48.93-6.13,54.41l-3.74,50.23c.39,1.71,7.36,32.05,10.31,37.31,2.7,4.84,12.06,32.31,14.86,40.61Zm-140.41-1h139c-2.42-7.17-11.92-35.06-14.57-39.78-3.09-5.52-10.12-36.34-10.42-37.65l0-.08v-.07L449,312c2.1-18.39,6.09-53.38,6.12-54.32,0-.67-.63-6.23-.91-8.62-3.6-2.09-50.19-29.06-56-29.89a18.14,18.14,0,0,0-9.21,1.19,12.79,12.79,0,0,1-3,.8l-1.17.09c-14.44,1.1-23.35,2.32-26.49,3.63-3.5,1.46-19.83,8.36-32.92,13.89a11.56,11.56,0,0,0-7,9.84l-5.22,69.57-.35.09c-2,.49-3.92,1.32-4,1.73a42.39,42.39,0,0,1-1.07,5.43,21.07,21.07,0,0,0,7,6.93h0c5,3.05,10.07,5.7,10.12,5.72l.25.13,0,.28,5.74,67.76Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "389.07px 329.475px 0px",
        }}
        id="eluhojbdmwxkm"
        className="animable"
      />
      <path
        d="M441.89,408.92l-.11-1c5-.55,5.77-.63,5.91-.63v1C447.5,408.3,445.55,408.51,441.89,408.92Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "444.735px 408.105px 0px",
        }}
        id="elas0sdj72924"
        className="animable"
      />
      <path
        d="M394.07,414.39l-.11-1s28.71-3.32,44.15-5.07l.11,1C422.79,411.07,394.07,414.39,394.07,414.39Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "416.09px 411.355px 0px",
        }}
        id="els1czd1xucp"
        className="animable"
      />
      <polygon
        points="395.76 421.46 395.05 418.27 396.03 418.06 396.54 420.35 446.72 414.01 446.84 415 395.76 421.46"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "420.945px 417.735px 0px",
        }}
        id="elfv90f53oykm"
        className="animable"
      />
      <ellipse
        cx={348.04}
        cy={295.38}
        rx={8.54}
        ry={8.88}
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "348.04px 295.38px 0px",
        }}
        id="elwn0dzn80w0j"
        className="animable"
      />
      <path
        d="M348,304.76a9.39,9.39,0,1,1,9-9.38A9.23,9.23,0,0,1,348,304.76ZM348,287a8.39,8.39,0,1,0,8,8.38A8.23,8.23,0,0,0,348,287Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "347.611px 295.378px 0px",
        }}
        id="elhjitx50q2uo"
        className="animable"
      />
      <path
        d="M353.82,295.38a5.78,5.78,0,1,1-5.78-6A5.9,5.9,0,0,1,353.82,295.38Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "348.043px 295.16px 0px",
        }}
        id="elctk9wnv5hrm"
        className="animable"
      />
      <path
        d="M348,301.89a6.51,6.51,0,1,1,6.28-6.51A6.4,6.4,0,0,1,348,301.89Zm0-12a5.52,5.52,0,1,0,5.28,5.51A5.4,5.4,0,0,0,348,289.87Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "347.77px 295.384px 0px",
        }}
        id="eltgtmr8bhvs"
        className="animable"
      />
      <path
        d="M346.56,297.52h0a1,1,0,0,1-1-1c1.58-35.71,15.18-75.71,15.31-76.11a1,1,0,0,1,1.9.65c-.14.4-13.64,40.13-15.21,75.55A1,1,0,0,1,346.56,297.52Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "354.192px 258.625px 0px",
        }}
        id="el30acs1j1p2g"
        className="animable"
      />
      <g id="elurmhnneba2d">
        <rect
          x={353.55}
          y={272.86}
          width={21.87}
          height={1}
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "364.485px 273.36px 0px",
            transform: "rotate(-47.02deg)",
          }}
          className="animable"
        />
      </g>
      <path
        d="M413.34,242.51l-.9-.44a14.74,14.74,0,0,0,1.65-4.67l1,.08A15.58,15.58,0,0,1,413.34,242.51Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "413.765px 239.955px 0px",
        }}
        id="el7q6t38xxfq8"
        className="animable"
      />
      <path
        d="M372.15,292.86l-.72-.69c8.17-8.57,22.29-23.4,25.09-26.5a152.14,152.14,0,0,0,13.65-19.41l.86.51a153.27,153.27,0,0,1-13.76,19.57C394.46,269.45,380.32,284.29,372.15,292.86Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "391.23px 269.56px 0px",
        }}
        id="elb5wu36o7tz6"
        className="animable"
      />
      <g id="elc1xaxtfmv4p">
        <rect
          x={364.42}
          y={296.62}
          width={5.94}
          height={1}
          style={{
            fill: "rgb(38, 50, 56)",
            transformOrigin: "367.39px 297.12px 0px",
            transform: "rotate(-46.27deg)",
          }}
          className="animable"
        />
      </g>
      <path
        d="M401.77,221.56s-3.37-8-3.67-11.26-.31-14.94-.31-14.94c-19.41-1.54-41.28,16.79-41.28,16.79l5.55,12.78.26,1.66a60.74,60.74,0,0,0,2.38,19.59c3.62,12.15,9.17,17.91,9.17,17.91s17.31-16.27,26-28.36C404.3,229.6,401.77,221.56,401.77,221.56Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "379.5px 229.679px 0px",
        }}
        id="elza7kdug67ad"
        className="animable"
      />
      <path
        d="M373.85,264.79l-.34-.35c-.23-.24-5.67-6-9.29-18.12a61.82,61.82,0,0,1-2.4-19.76l-.24-1.49L355.91,212l.28-.24c.22-.18,22.26-18.44,41.64-16.9l.46,0v.46c0,.12,0,11.72.3,14.89s3.61,11,3.64,11.11l0,0c.11.33,2.55,8.35-2,14.62-8.63,12-25.91,28.26-26.08,28.42Zm-16.73-52.5,5.43,12.56.26,1.66A61.36,61.36,0,0,0,365.18,246c3,10.21,7.48,15.89,8.72,17.33,2.57-2.44,17.7-17,25.57-27.93,4.12-5.72,2-13.27,1.83-13.71s-3.4-8.17-3.7-11.39c-.28-2.89-.31-12.28-.31-14.52C379.62,194.72,359.74,210.19,357.12,212.29Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "379.446px 229.779px 0px",
        }}
        id="elcsqda8ue1wf"
        className="animable"
      />
      <path
        d="M385.88,220.67s-9.76,10.27-12.74,13.75-8.7,9.7-8.7,9.7a71,71,0,0,1-2-12.43,45.13,45.13,0,0,1,1-9.95Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "374.159px 232.395px 0px",
        }}
        id="el7a2u9e76ew"
        className="animable"
      />
      <path
        d="M364.18,245.14l-.23-.9a71.23,71.23,0,0,1-2-12.54,44.55,44.55,0,0,1,1-10.07l.08-.37,24.06-1.14-.86.9c-.09.1-9.78,10.3-12.72,13.73s-8.66,9.65-8.71,9.71Zm-.33-22.91a44.57,44.57,0,0,0-.9,9.45,65.17,65.17,0,0,0,1.76,11.41c1.57-1.72,5.69-6.24,8.05-9s9.45-10.28,11.9-12.87Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "374.518px 232.63px 0px",
        }}
        id="elpv1ggu26eyk"
        className="animable"
      />
      <path
        d="M323.69,335.76c-.59-8.75-1.87-25.83-2.53-27.8-1-2.88,0-42.39,2.75-56.54l1,.18c-2.76,14.4-3.57,53.72-2.79,56,.86,2.59,2.51,27,2.58,28.06Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "322.846px 293.59px 0px",
        }}
        id="el55kju5s3usl"
        className="animable"
      />
      <path
        d="M351.3,133.29s-8.64,12.49-11,15.92-6.08,2.28-5.41,8,5.29,16.2,11.16,17.93a21.88,21.88,0,0,0,11.29.12s32.73,13.63,34.9,16.62,4.27,10.38,4.27,10.38,8.42-.56,11.16-1.55a30.27,30.27,0,0,0,6.51-4.08l-2.79-1.22s5.16-2.39,5.78-2.87a33,33,0,0,1,3-1.7l-4.57-5.64-1-6s2.17-10.06,3.41-17.47-.73-17-6-21.6S385.37,125.74,374.21,126,352.75,132.16,351.3,133.29Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "377.49px 164.127px 0px",
        }}
        id="elztaehj0ykjk"
        className="animable"
      />
      <path
        d="M396.16,202.84l-.11-.39c0-.07-2.1-7.35-4.2-10.23-1.52-2.1-21.41-10.92-34.52-16.39a22.19,22.19,0,0,1-11.4-.16c-6.4-1.89-10.9-12.95-11.52-18.35-.46-4,1.14-5,2.84-6.08a7.89,7.89,0,0,0,2.65-2.32c2.35-3.42,11-15.92,11-15.92l.1-.11c2-1.55,12.47-7.12,23.21-7.38,11.22-.26,32.74,9.55,38.18,14.3,5.65,4.94,7.38,14.84,6.17,22.06-1.17,7-3.18,16.36-3.4,17.4l1,5.77,4.88,6-.55.28c-.65.34-2.46,1.28-2.94,1.65s-3.31,1.73-4.88,2.46l2.53,1.1-.63.52a30,30,0,0,1-6.66,4.17c-2.77,1-10.95,1.56-11.3,1.58Zm-38.77-28.06.17.06c3.36,1.41,32.92,13.78,35.1,16.79,1.94,2.67,3.76,8.57,4.23,10.16,1.7-.13,8.32-.67,10.63-1.5a26.24,26.24,0,0,0,5.71-3.49l-3-1.33,1-.47c2-.91,5.26-2.48,5.69-2.81a23.23,23.23,0,0,1,2.55-1.47l-4.27-5.26-1-6.21,0-.1c0-.1,2.19-10.13,3.41-17.44,1.14-6.78-.53-16.5-5.84-21.15s-26.52-14.36-37.5-14-21.15,6.1-22.56,7.13c-.68,1-8.69,12.57-10.93,15.85a8.94,8.94,0,0,1-3,2.6c-1.6,1-2.76,1.74-2.38,5.12.68,5.9,5.34,15.89,10.81,17.51a21.78,21.78,0,0,0,11,.11Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "377.685px 164.172px 0px",
        }}
        id="elxj6bjrtfwwj"
        className="animable"
      />
      <path
        d="M391.28,217.5s-14.55,12.72-21.8,12.35-15.65-16.17-16.74-18.77-5.1-14-5.31-16.92-1.74-20.06-1.39-22.51S354.53,156,354.53,156s3.77,8.68,7.75,13,12.45,6.31,12.45,6.31L373.05,171s7.21,5.12,10.91,5.52,8.19,1.08,8.19,1.08,3.59,5.57,4.5,6.49,3.58-.23,3.58-.23,5.4-5.63,8.51-4.06.49,11.23-1.76,15.34-7.1,7.31-7.1,7.31l-2.17.59s-2.33,7.61-3.48,9.77"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "378.077px 192.929px 0px",
        }}
        id="elge558bypvx8"
        className="animable"
      />
      <path
        d="M369.79,230.36h-.33c-7.63-.38-16.16-16.64-17.18-19.08s-5.12-13.94-5.35-17.08c0-.54-.12-1.57-.23-2.9-.51-6.17-1.44-17.66-1.15-19.71.35-2.48,7.72-14.48,8.56-15.84l.5-.81.38.88c0,.08,3.79,8.66,7.65,12.9,3.06,3.36,9,5.27,11.27,5.92l-1.93-5,1.36,1c.08.05,7.14,5.05,10.67,5.43s8.17,1.08,8.22,1.09l.22,0,.12.19c1,1.54,3.72,5.68,4.44,6.41.44.45,2,.09,2.94-.31.7-.71,5.78-5.71,9-4.07a2.89,2.89,0,0,1,1.41,1.85c1.06,3.42-1.05,10.68-3,14.17-2.29,4.16-7.06,7.35-7.26,7.48L400,203l-1.91.52a91,91,0,0,1-3.43,9.59l-.89-.47a95.86,95.86,0,0,0,3.44-9.68l.08-.26,2.36-.64c.58-.4,4.84-3.4,6.87-7.09,1.79-3.26,3.85-10.27,2.88-13.4a2,2,0,0,0-.9-1.25c-2.28-1.16-6.49,2.46-7.92,4l-.17.11c-.49.22-3,1.25-4.13.13-.85-.86-3.8-5.37-4.45-6.38-1-.14-4.76-.7-8-1-2.83-.3-7.51-3.18-9.8-4.69l1.44,3.7-.92-.21c-.35-.09-8.68-2-12.71-6.46-3.29-3.61-6.38-10-7.45-12.32-2.51,4.12-7.67,12.86-7.92,14.65-.28,1.94.69,13.8,1.16,19.49.11,1.34.19,2.37.23,2.91.2,2.78,4.07,13.9,5.27,16.77.95,2.24,9.3,18.11,16.31,18.46s21.29-12.1,21.44-12.23l.66.76C391,218.39,377.24,230.36,369.79,230.36Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "378.07px 192.65px 0px",
        }}
        id="elgn2vaupxx4v"
        className="animable"
      />
      <path
        d="M364.09,206.37a2.49,2.49,0,0,1-2.24-1c-1.22-1.87-.66-5-.64-5.18l1,.18s-.51,2.92.5,4.46c.73,1.13,3.64.18,4.6-.24l.25-.11.23.14a2.05,2.05,0,0,0,2,0,.94.94,0,0,0,.48-1.33l.9-.44a1.94,1.94,0,0,1-.92,2.66,3.16,3.16,0,0,1-2.75,0A10.1,10.1,0,0,1,364.09,206.37Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "366.226px 203.286px 0px",
        }}
        id="el0ptlfdxoe45l"
        className="animable"
      />
      <path
        d="M368.49,213.34c-.3,0-.6,0-.9,0-4.77-.52-6.25-2.35-6.31-2.43l.78-.62s1.35,1.59,5.64,2.05,9.87-3.28,9.92-3.32l.57.82C378,210,373,213.34,368.49,213.34Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "369.735px 211.18px 0px",
        }}
        id="elhhlczgnep2l"
        className="animable"
      />
      <path
        d="M360.72,181.21a10.62,10.62,0,0,0-5.67-1.46c-3.12.16-4.15.77-4.16.78l-.54-.84c.11-.08,1.24-.77,4.65-.94a11.31,11.31,0,0,1,6.27,1.63Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "355.81px 179.976px 0px",
        }}
        id="el0qn7e2g57v5"
        className="animable"
      />
      <path
        d="M387.52,183.93a13.54,13.54,0,0,0-6-1.92,66.57,66.57,0,0,0-10.17.62l-.13-1a65.24,65.24,0,0,1,10.37-.63,14.51,14.51,0,0,1,6.52,2.09Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "379.665px 182.459px 0px",
        }}
        id="elzn5l1o3ln9p"
        className="animable"
      />
      <path
        d="M399.39,194.93l-.53-.85c.8-.51,2.16-1.6,2.39-2.38s-.63-1.85-1-2.2l-.27-.26.19-.34c.11-.2,2.83-5,5.14-6.11a2.17,2.17,0,0,1,1.86-.07c1.39.62,2,2.66,2,2.75l-1,.28a3.76,3.76,0,0,0-1.47-2.12,1.19,1.19,0,0,0-1,.06c-1.56.75-3.64,3.9-4.52,5.39a3.38,3.38,0,0,1,1,2.9C401.8,193.37,399.64,194.77,399.39,194.93Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "404.015px 188.737px 0px",
        }}
        id="elqtqwwl91eg"
        className="animable"
      />
      <path
        d="M400.88,189.58l-.51-.86c.16-.1,4-2.34,6.05-.66l-.63.78C404.51,187.81,401.82,189,400.88,189.58Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "403.395px 188.509px 0px",
        }}
        id="eln035u1r43"
        className="animable"
      />
      <path
        d="M357.53,188.91c.05,1.69-.79,3.12-1.88,3.19s-2-1.25-2.08-2.94.79-3.13,1.88-3.2S357.47,187.21,357.53,188.91Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "355.549px 189.03px 0px",
        }}
        id="el4s6p9a0j8qe"
        className="animable"
      />
      <path
        d="M377.53,191c-.06,1.69-1,3.07-2.08,3.07s-1.93-1.38-1.88-3.08,1-3.07,2.08-3.07S377.59,189.31,377.53,191Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "375.55px 190.995px 0px",
        }}
        id="elhwid4mbm5rv"
        className="animable"
      />
      <polygon
        points="362.83 197.36 361.83 197.33 362.11 188.99 361.13 183.45 362.11 183.27 363.11 188.92 362.83 197.36"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "362.12px 190.315px 0px",
        }}
        id="elizkmjf6w7ht"
        className="animable"
      />
      <path
        d="M398.94,280a2.21,2.21,0,0,1-.35,0,1.51,1.51,0,0,1-1.11-1.81c0-.07,1.67-7,3.55-15.75a1.5,1.5,0,0,1,2.93.63c-1.89,8.74-3.54,15.74-3.56,15.81A1.51,1.51,0,0,1,398.94,280Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "400.711px 270.664px 0px",
        }}
        id="elw0n8r7lvbvf"
        className="animable"
      />
      <path
        d="M402.49,263.75l-.21,0a1,1,0,0,1-.77-1.19c4.2-19.44,6.17-31.89,5.56-35-1.22-6.28-5.66-7.37-5.84-7.41a1,1,0,0,1,.43-2c.24.06,5.9,1.37,7.37,9,.68,3.52-1.19,15.58-5.56,35.86A1,1,0,0,1,402.49,263.75Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "404.794px 240.939px 0px",
        }}
        id="eloekfd8j29j"
        className="animable"
      />
      <path
        d="M382.09,344l-.23,0a12.33,12.33,0,0,1-5.91-2.79,1.5,1.5,0,0,1,2-2.28,9.38,9.38,0,0,0,4.4,2.11,1.5,1.5,0,0,1-.22,3Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "379.589px 341.299px 0px",
        }}
        id="elajl86097suu"
        className="animable"
      />
      <path
        d="M382.09,344.52l-.31,0a13,13,0,0,1-6.16-2.92,2,2,0,0,1,2.62-3,8.72,8.72,0,0,0,4.15,2,2,2,0,0,1,1.31.8,1.91,1.91,0,0,1,.36,1.48A2,2,0,0,1,382.09,344.52Zm-5.16-5.45a1,1,0,0,0-.65,1.76,11.91,11.91,0,0,0,5.66,2.68,1,1,0,0,0,1.14-.84,1,1,0,0,0-.19-.74,1,1,0,0,0-.65-.4,9.9,9.9,0,0,1-4.66-2.22A1,1,0,0,0,376.93,339.07Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "379.578px 341.371px 0px",
        }}
        id="el21i3rr49wv5"
        className="animable"
      />
      <path
        d="M376.93,341.07a1,1,0,0,1-.65-.24c-2.27-2-4.7-5.67-3.37-12.17,2-10,9.06-34.9,9.13-35.15a1,1,0,1,1,1.92.55c-.07.25-7.07,25.13-9.09,35-.91,4.46,0,7.91,2.71,10.25a1,1,0,0,1-.65,1.76Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "378.273px 316.902px 0px",
        }}
        id="elbg9533fo6ys"
        className="animable"
      />
      <path
        d="M376.93,341.57a1.52,1.52,0,0,1-1-.36c-2.37-2-4.91-5.91-3.53-12.66,1.95-9.52,8.4-32.55,9.13-35.14a1.5,1.5,0,1,1,2.89.78c-.07.24-7.07,25.13-9.08,35-.88,4.27,0,7.56,2.55,9.77a1.54,1.54,0,0,1,.52,1,1.49,1.49,0,0,1-.36,1.09A1.51,1.51,0,0,1,376.93,341.57ZM383,293.29a.49.49,0,0,0-.48.36c-.74,2.62-7.18,25.62-9.12,35.11-1.28,6.27,1,9.82,3.2,11.69a.45.45,0,0,0,.71-.05.5.5,0,0,0,.12-.37.51.51,0,0,0-.17-.34c-2.86-2.47-3.83-6.08-2.88-10.73,2-9.87,9-34.8,9.1-35a.51.51,0,0,0-.35-.62Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "378.255px 316.887px 0px",
        }}
        id="el5vrytkrug4s"
        className="animable"
      />
      <path
        d="M383.58,340.82a17.87,17.87,0,0,1-6.6-1.46,1.5,1.5,0,1,1,1.11-2.79,14.57,14.57,0,0,0,5.8,1.24,1.5,1.5,0,0,1,.1,3Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "380.737px 338.642px 0px",
        }}
        id="elb5lywl8j7h"
        className="animable"
      />
      <path
        d="M383.58,341.32a18.29,18.29,0,0,1-6.79-1.5,2,2,0,0,1,1.48-3.71,14.13,14.13,0,0,0,5.6,1.2,2,2,0,0,1,1.42.53,2,2,0,0,1-1.28,3.47ZM377.53,337a1,1,0,0,0-.93.63,1.08,1.08,0,0,0,0,.77,1,1,0,0,0,.55.53,16.57,16.57,0,0,0,6.81,1.42,1,1,0,0,0,1-1,1,1,0,0,0-.33-.7.94.94,0,0,0-.7-.27,15.17,15.17,0,0,1-6-1.27A1,1,0,0,0,377.53,337Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "380.782px 338.662px 0px",
        }}
        id="elh0p931u3he4"
        className="animable"
      />
      <path
        d="M383.94,340.31a1,1,0,0,1,0-2c3.52-.12,6-2.28,7.49-6.6,2.92-8.3,10.38-35,10.46-35.23a1,1,0,1,1,1.92.53c-.07.27-7.55,27-10.49,35.36-1.8,5.12-4.93,7.79-9.31,7.94Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "393.407px 317.984px 0px",
        }}
        id="elx9scsgn1v5g"
        className="animable"
      />
      <path
        d="M383.94,340.81a1.49,1.49,0,0,1-1.5-1.44,1.47,1.47,0,0,1,.4-1.08,1.54,1.54,0,0,1,1.05-.48c3.29-.11,5.59-2.16,7-6.26,2.87-8.18,10.14-34.11,10.45-35.21a1.48,1.48,0,0,1,.71-.9,1.5,1.5,0,0,1,2.18,1.71c-.31,1.1-7.61,27.13-10.51,35.39-1.87,5.33-5.16,8.12-9.76,8.27Zm18.87-44.56a.5.5,0,0,0-.24.06.48.48,0,0,0-.24.3c-.31,1.1-7.59,27.06-10.47,35.27-1.59,4.54-4.19,6.81-7.94,6.93a.57.57,0,0,0-.35.16.49.49,0,0,0-.13.36.5.5,0,0,0,.5.48v0c4.17-.14,7.14-2.7,8.87-7.6C395.7,324,403,298,403.29,296.88a.5.5,0,0,0-.34-.62Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "393.362px 318.029px 0px",
        }}
        id="elx4u3ojqbehl"
        className="animable"
      />
      <path
        d="M401.45,303a1.65,1.65,0,0,1-.38,0,1.51,1.51,0,0,1-1.08-1.83c2-7.68,3.53-16.91,2.71-18.38-.7-1-3.54-2.46-6.65-2.89-2.14-.3-3.93,0-4.79.7-2.1,1.8-5.73,10.61-7.53,15.75a1.5,1.5,0,0,1-2.83-1c.5-1.44,5-14.13,8.41-17,1.54-1.32,4.08-1.82,7.15-1.39s7.22,1.93,8.74,4.2c2,3-.95,15.53-2.3,20.79A1.51,1.51,0,0,1,401.45,303Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "393.345px 289.91px 0px",
        }}
        id="el8s67tef8a8s"
        className="animable"
      />
      <path
        d="M247,302.1s-12.11-3-14.54-3.84-9.49-6.06-10.7-4,0,7.07,2.63,8.69,10.9,4.64,10.9,4.64,6.66,11.71,8.88,13.12,9.09,1,9.09,1"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "237.275px 307.774px 0px",
        }}
        id="elftz3ye19o3a"
        className="animable"
      />
      <path
        d="M251.11,322.24c-2.26,0-5.67-.18-7.2-1.15C241.73,319.71,236,309.73,235,308c-1.24-.46-8.37-3.12-10.83-4.63-2.9-1.79-4.14-7.11-2.79-9.36,1.09-1.81,4.63.2,8,2.14a25.19,25.19,0,0,0,3.24,1.68c2.38.79,14.38,3.79,14.5,3.82l-.24,1c-.5-.12-12.16-3-14.57-3.84a24.54,24.54,0,0,1-3.43-1.76c-2.13-1.21-6.11-3.47-6.69-2.5-1.08,1.8.12,6.56,2.46,8,2.55,1.57,10.73,4.57,10.81,4.6l.17.06.09.16c1.84,3.23,7,11.85,8.72,12.95s6.93,1,8.79.93l.06,1C253.2,322.19,252.32,322.24,251.11,322.24Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "237.062px 307.776px 0px",
        }}
        id="el1ct6v0qqqb3j"
        className="animable"
      />
      <path
        d="M133.81,329.78l16.55-2.71L141,311.27S132.14,323.11,133.81,329.78Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "141.98px 320.525px 0px",
        }}
        id="eli5xhze8rz1f"
        className="animable"
      />
      <path
        d="M133.44,330.34l-.12-.44c-1.7-6.82,6.9-18.44,7.27-18.93l.45-.6,10.12,17.08ZM141,312.18c-1.7,2.43-7.7,11.46-6.75,17l15.36-2.51Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "142.129px 320.355px 0px",
        }}
        id="elw67k4d5zavs"
        className="animable"
      />
      <path
        d="M183.48,307.2l16.73,33.72s22.69,7.48,33.64,11.22,35,13.08,40.32,13.61a96,96,0,0,0,13.09,0s10.41-9.61,11.48-10.14a36.35,36.35,0,0,1,8.28-2.14c2.67-.27,12-3.2,12-3.2s5.08-4.54,5.88-1.07-2.67,6.41-4.27,7.48-5.88,2.4-7.21,2.93c0,0,11.75,1.07,12.55,1.07s11.21-2.4,11.21-2.4,10.71-5.66,12-4.38.37,2.76-.92,4a23.9,23.9,0,0,0-2.57,3.31,44.5,44.5,0,0,1-5.14,9c-3.5,4.77-12.5,12.67-13.42,13.23s-16.54,3.49-33.26,4-43.55,1.29-53.29.92-37.48-4.41-46.49-6.07-16.54-1.83-18-5-7.53-10.66-14.7-21.13-17.27-29.77-18-31.79a49.31,49.31,0,0,0-3.86-6.61s7.16-12.5,17.82-16S183.48,307.2,183.48,307.2Z"
        style={{
          fill: "rgb(227, 227, 227)",
          transformOrigin: "244.666px 344.702px 0px",
        }}
        id="elyzgyqyvvhv"
        className="animable"
      />
      <path
        d="M247.63,389.05c-2.82,0-5.24,0-7.07-.1-9.81-.37-37.74-4.45-46.56-6.07-2.2-.41-4.27-.72-6.27-1-6.31-.94-10.87-1.63-12.1-4.23-.82-1.75-3.14-4.94-6.36-9.37C166.94,365,164,361,161,356.57c-7.09-10.36-17.3-29.8-18.06-31.9a48.68,48.68,0,0,0-3.81-6.5l-.17-.26.15-.27c.3-.52,7.39-12.71,18.11-16.22s25.9,5,26.54,5.34l.13.08.07.14,16.63,33.53c2.27.75,23.17,7.64,33.45,11.15,3.25,1.11,7.67,2.72,12.35,4.42,10.76,3.93,24.17,8.81,27.86,9.18a97.68,97.68,0,0,0,12.83,0c1.54-1.43,10.4-9.58,11.47-10.11A37.24,37.24,0,0,1,307,353c2.44-.24,10.8-2.83,11.81-3.15.61-.53,3.48-2.91,5.31-2.34a2,2,0,0,1,1.31,1.61c1,4.14-3.57,7.39-4.49,8a29.4,29.4,0,0,1-5.2,2.23c3.9.35,9.74.86,10.27.86s7-1.46,11-2.38c3.34-1.76,11.13-5.64,12.52-4.25s1,2.87-.92,4.75a22.19,22.19,0,0,0-2.51,3.22,43.29,43.29,0,0,1-5.16,9c-3.55,4.85-12.61,12.79-13.56,13.37s-16.57,3.55-33.5,4.11C285.78,388.3,261.77,389.05,247.63,389.05ZM140.11,317.87a45.38,45.38,0,0,1,3.74,6.46c.75,2.08,10.9,21.37,18,31.68,3,4.46,5.95,8.45,8.28,11.66,3.25,4.47,5.59,7.7,6.46,9.54,1,2.11,5.56,2.8,11.33,3.66,2,.3,4.1.61,6.31,1,8.8,1.62,36.65,5.69,46.42,6.06,11,.42,43.54-.6,53.25-.92,17-.56,32.14-3.51,33-4s9.87-8.45,13.26-13.09a43.91,43.91,0,0,0,5.08-8.89,22.9,22.9,0,0,1,2.69-3.48c1.88-1.88,1.48-2.77.92-3.34s-5.92,1.57-11.4,4.47l-.13,0c-1.74.41-10.51,2.42-11.32,2.42s-12.12-1-12.6-1.07l-2.07-.19,1.93-.77c.35-.14.9-.34,1.56-.57a33.65,33.65,0,0,0,5.56-2.32c.82-.55,4.87-3.45,4.06-6.95-.17-.73-.51-.84-.63-.87-1.05-.33-3.27,1.17-4.42,2.2l-.19.1c-.38.12-9.42,3-12.11,3.23a36.6,36.6,0,0,0-8.11,2.08c-.73.37-7.36,6.37-11.36,10.07l-.13.12h-.18a97.65,97.65,0,0,1-13.17,0c-3.82-.38-16.72-5.08-28.11-9.23-4.67-1.7-9.08-3.31-12.32-4.41-10.82-3.7-33.41-11.14-33.64-11.21l-.2-.07L183.1,307.56c-1.52-.83-15.8-8.4-25.6-5.18C148,305.49,141.22,316.06,140.11,317.87Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "244.66px 344.811px 0px",
        }}
        id="elcrnyjww9ad5"
        className="animable"
      />
      <path
        d="M322.7,373.46l-.4-.92a61.06,61.06,0,0,1,8.15-1.55c.89-.13,1.57-.24,1.82-.29.84-.17,3.37-1.87,5.21-3.51s8.8-7.6,8.87-7.66l.65.76c-.07.06-7.07,6.06-8.86,7.65s-4.5,3.51-5.67,3.74l-1.87.3A67.81,67.81,0,0,0,322.7,373.46Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "334.65px 366.495px 0px",
        }}
        id="elkrrq4pkoaut"
        className="animable"
      />
      <path
        d="M325.1,378.5l-.37-.92,9-3.61c.38-.27,2.83-2,3.57-2.58s4.42-3.41,4.42-3.41l.62.78s-3.63,2.83-4.44,3.44-3.64,2.62-3.64,2.62l-.1.06Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "333.535px 373.24px 0px",
        }}
        id="elgqueqfe0bxj"
        className="animable"
      />
      <path
        d="M241.49,354.85c-2.88-1.05-5.51-2-7.64-2.71-10.95-3.74-33.64-11.22-33.64-11.22l-9.49-19.13c-23.24-.55-33.46,12.46-37.65,21,2.77,4.84,5.73,9.76,8.31,13.53,7.17,10.47,13.23,18,14.7,21.13s9,3.31,18,5c7.95,1.46,30.48,4.78,42.37,5.79-2-3.6-4.84-10.76-2.32-18.48A59.21,59.21,0,0,1,241.49,354.85Z"
        style={{
          fill: "rgb(97, 185, 255)",
          transformOrigin: "197.28px 355.007px 0px",
        }}
        id="elcu7w43z60y"
        className="animable"
      />
      <path
        d="M237.34,388.75l-.93-.08c-11.89-1-34.62-4.36-42.41-5.79-2.2-.41-4.27-.72-6.27-1-6.31-.94-10.87-1.63-12.1-4.23-.82-1.75-3.14-4.94-6.36-9.37C166.94,365,164,361,161,356.57c-2.32-3.4-5.13-8-8.33-13.57l-.14-.23.12-.23c4-8.18,14.32-21.83,38.11-21.25h.3l9.53,19.21c2.27.75,23.17,7.64,33.45,11.15,1.86.64,4.22,1.47,7.65,2.72l.61.22-.36.53a58.72,58.72,0,0,0-7.3,14.71c-2.46,7.55.38,14.58,2.29,18.1Zm-83.7-46c3.13,5.47,5.88,9.94,8.16,13.27,3,4.46,5.95,8.45,8.28,11.66,3.25,4.47,5.59,7.7,6.46,9.54,1,2.11,5.56,2.8,11.33,3.66,2,.3,4.1.61,6.31,1,7.58,1.39,29.33,4.61,41.41,5.71-1.94-3.87-4.33-10.72-1.93-18.07a59.69,59.69,0,0,1,7.06-14.43c-3.11-1.12-5.29-1.9-7-2.49-10.82-3.7-33.41-11.14-33.64-11.21l-.2-.07-9.44-19C167.65,321.87,157.62,334.79,153.64,342.74Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "197.415px 355.011px 0px",
        }}
        id="ell86bgi18xb"
        className="animable"
      />
      <path
        d="M179.72,367.93l-.95-.31c2.44-7.42,8.17-20.58,19.17-25.39l.4.92C187.69,347.8,182.1,360.67,179.72,367.93Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "188.555px 355.08px 0px",
        }}
        id="el3u615tjlqzr"
        className="animable"
      />
      <path
        d="M177.93,374.51l-1-.19s.2-1.06.64-2.74l1,.26C178.13,373.48,177.93,374.5,177.93,374.51Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "177.75px 373.045px 0px",
        }}
        id="elc3a21ree0qh"
        className="animable"
      />
      <path
        d="M188.36,332.83l-.27-1a25.61,25.61,0,0,1,5.29-.93l.07,1A25.13,25.13,0,0,0,188.36,332.83Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "190.77px 331.865px 0px",
        }}
        id="el6hmh1l91w3l"
        className="animable"
      />
      <path
        d="M164.4,357.05l-.92-.37c.06-.16,6.32-15.45,18.78-22.38l.48.88C170.6,341.92,164.46,356.9,164.4,357.05Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "173.11px 345.675px 0px",
        }}
        id="elrvnvrypk4x"
        className="animable"
      />
      <path
        d="M201.69,381.46c-2.47-16,11-34.16,11.12-34.34l.8.59c-.13.18-13.34,18-10.93,33.6Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "207.499px 364.29px 0px",
        }}
        id="elc7outi5kulj"
        className="animable"
      />
      <path
        d="M220.37,384.16a40.84,40.84,0,0,1-.41-6.81l1,0a40,40,0,0,0,.4,6.64Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "220.654px 380.755px 0px",
        }}
        id="el0ynw5jxliwr"
        className="animable"
      />
      <path
        d="M221.33,373l-1-.14a43.49,43.49,0,0,1,8.92-20.8l.75.66A42.43,42.43,0,0,0,221.33,373Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "225.165px 362.53px 0px",
        }}
        id="el92n46inmr0s"
        className="animable"
      />
      <path
        d="M126.47,266.27s-6.77,17.78-5.93,23.15,11.29,35,11.58,36.12a42.33,42.33,0,0,0,1.69,4.24s13.26-18.91,26-21.74a66.87,66.87,0,0,1,23.71-.84l-6.21-14.11a99.85,99.85,0,0,0-.84-10.45c-.57-2.54-10.45-13.54-16.94-15.24"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "151.994px 298.025px 0px",
        }}
        id="elsa4wl25qjms"
        className="animable"
      />
      <path
        d="M133.72,330.78l-.37-.8a44.34,44.34,0,0,1-1.72-4.32c-.06-.25-.8-2.41-1.73-5.13-3.22-9.42-9.2-26.94-9.85-31-.86-5.44,5.68-22.67,6-23.4l.94.35c-.07.18-6.72,17.72-5.9,22.89.63,4,6.83,22.15,9.81,30.87,1.13,3.32,1.68,4.93,1.75,5.21a31.18,31.18,0,0,0,1.31,3.36c2.6-3.53,14.27-18.67,25.76-21.22a68.83,68.83,0,0,1,23-1l-5.89-13.47a97.78,97.78,0,0,0-.83-10.35c-.49-2.18-10.18-13.2-16.57-14.86l.25-1c6.7,1.75,16.67,12.82,17.3,15.62a95.47,95.47,0,0,1,.85,10.43l6.55,14.88-.93-.16a66.83,66.83,0,0,0-23.51.84c-12.36,2.75-25.53,21.35-25.66,21.53Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "152.176px 298.455px 0px",
        }}
        id="eldb52pzypash"
        className="animable"
      />
      <path
        d="M172.36,287.88s-1.3-1.22-3-2.73l.66-.75c1.72,1.53,3,2.75,3,2.75Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "171.19px 286.14px 0px",
        }}
        id="elcyj4u3zredl"
        className="animable"
      />
      <path
        d="M167,283.12c-3.5-2.95-4.71-3.56-5.12-3.66-1.61-.41-6.87,1.58-8.76,2.37l-.39-.92c.72-.3,7.16-3,9.39-2.42.33.08,1.33.33,5.52,3.87Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "160.185px 280.764px 0px",
        }}
        id="elqe8e6885ouj"
        className="animable"
      />
      <path
        d="M317.15,385.41s-11.08-3.2-14.92-4.69-11.09-5.55-13.22-6.4-13.22,0-14.5,0-6.82-1.28-7.89-.21.64,3.62,1.92,4.47,9.6,2.35,9.6,2.35l7.25,2.56-14.29,2.13-13.43,2.56a4.19,4.19,0,0,0,2.13,2.13c1.71.85,8.32,1.92,8.32,1.92s16.41,6.4,20.46,7c3.17.51,11.33,1.09,14.73,1.32a17.34,17.34,0,0,0,3.06-.07c4.43-.5,17.43-2,25.12-3.41,9.38-1.71,41-7.88,47.48-9.63,24.63-6.72,49.69-24.66,50.76-25.3a25.59,25.59,0,0,0,4.9-4.69c.43-.86,2.56-3.84,2.56-3.84L402,340.42l-2.67,1.87s-25.26,13.48-35.92,20.09-31.55,19.19-32.83,19.83S317.15,385.41,317.15,385.41Z"
        style={{
          fill: "rgb(255, 255, 255)",
          transformOrigin: "347.43px 370.504px 0px",
        }}
        id="elwji33ctg1v"
        className="animable"
      />
      <path
        d="M304.46,401.12c-.4,0-.79,0-1.18,0-3.37-.23-11.56-.81-14.77-1.32-4-.63-19.35-6.59-20.53-7.05-.67-.11-6.71-1.11-8.4-1.95a4.67,4.67,0,0,1-2.38-2.42l-.19-.55,14-2.66,12.31-1.84L278,381.4c-.78-.13-8.38-1.52-9.7-2.4a6.13,6.13,0,0,1-2.47-3.76,1.77,1.77,0,0,1,.47-1.49c.88-.87,3.32-.6,6.42-.15a17.8,17.8,0,0,0,1.82.22c.27,0,1,0,1.91-.09,5.71-.31,11.21-.5,12.78.13.9.36,2.68,1.27,4.74,2.32,2.78,1.43,6.25,3.21,8.47,4.07,3.56,1.38,13.55,4.29,14.76,4.64,4.87-1,12.3-2.68,13.19-3.13,1.24-.62,21.82-13,32.8-19.8,10.55-6.55,35.7-20,35.95-20.11l2.83-2,36,13.54-.38.53c-.59.82-2.18,3.1-2.52,3.77a25.19,25.19,0,0,1-5.09,4.89l-.74.5c-17.73,12-35.54,20.87-50.15,24.86-6.57,1.79-38.42,8-47.52,9.64-7.81,1.42-21.23,3-25.15,3.41A16.15,16.15,0,0,1,304.46,401.12Zm-46-12.58a4.26,4.26,0,0,0,1.6,1.32c1.61.81,8.1,1.86,8.17,1.88l.1,0c.16.07,16.41,6.39,20.36,7,3.18.5,11.33,1.08,14.69,1.31a16.4,16.4,0,0,0,3-.07c3.91-.44,17.3-2,25.08-3.41,9.09-1.65,40.89-7.83,47.44-9.62,14.5-4,32.21-12.73,49.85-24.72l.78-.52a26.56,26.56,0,0,0,4.72-4.49c.33-.66,1.58-2.46,2.22-3.37L402.08,341l-2.45,1.72c-.3.17-25.42,13.58-35.95,20.1-10.29,6.39-31.5,19.17-32.87,19.86s-12.3,3-13.55,3.24l-.12,0-.12,0c-.46-.13-11.16-3.22-15-4.71-2.27-.88-5.62-2.6-8.57-4.11-2-1-3.79-1.94-4.65-2.29-1.59-.63-9.13-.22-12.36,0-1,0-1.68.09-2,.09a17.39,17.39,0,0,1-2-.23c-1.62-.23-5-.72-5.57-.13a.74.74,0,0,0-.18.68,5.25,5.25,0,0,0,2,3c.87.58,6.23,1.7,9.41,2.27l9.22,3.24-16.27,2.43Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "347.49px 370.485px 0px",
        }}
        id="el3b7zii5rn9b"
        className="animable"
      />
      <path
        d="M417.22,267.47l-8.83,47.89-5.74,7.07-3.31,19.86s15,7.73,24.72,9.71,24.28,1.33,24.28,1.33l5.08-25.61.66-15.67s6.4-56.94,6-59.15-19.64-10.15-23.39-11.26a36.7,36.7,0,0,0-6-1.32"
        style={{
          fill: "rgb(97, 185, 255)",
          transformOrigin: "429.719px 296.876px 0px",
        }}
        id="eljsk14qv3hta"
        className="animable"
      />
      <path
        d="M442.67,353.93c-5.17,0-12.84-.24-18.71-1.44-9.66-2-24.69-9.68-24.84-9.76l-.33-.16,3.39-20.36,5.74-7.06,8.81-47.77,1,.18-8.85,48-5.73,7.06L399.9,342c2.24,1.13,15.52,7.71,24.26,9.5s21.39,1.42,23.77,1.33l5-25.22.65-15.59c2.57-22.85,6.28-57.39,6-59-.5-1.85-18.61-9.57-23.05-10.88a36.21,36.21,0,0,0-5.86-1.3l.1-1a37.28,37.28,0,0,1,6.05,1.34c2.55.75,23.19,8.9,23.74,11.64.45,2.22-5.29,53.47-5.95,59.31l-.66,15.63-5.16,26.07-.39,0C448.31,353.83,446,353.93,442.67,353.93Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "429.688px 296.885px 0px",
        }}
        id="elm9eimrvehc"
        className="animable"
      />
      <path
        d="M419,311.37l-.44-.9c6.52-3.13,17.91-8.77,21.11-11.39l.63.78C437.16,302.4,427,307.52,419,311.37Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "429.43px 305.225px 0px",
        }}
        id="elpzbsyhfupke"
        className="animable"
      />
      <path
        d="M412.36,314.49l-.42-.91s1.42-.65,3.63-1.7l.43.9Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "413.97px 313.185px 0px",
        }}
        id="el3lakxmjhz3v"
        className="animable"
      />
      <path
        d="M431,301.65l-.55-.83c6.27-4.11,16.79-15.91,16.9-16l.75.67C447.62,286,437.34,297.47,431,301.65Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "439.275px 293.235px 0px",
        }}
        id="elb4uycmz8nxj"
        className="animable"
      />
    </g>
    <g
      id="freepik--table-1--inject-359"
      style={{
        transformOrigin: "371.155px 440.42px 0px",
      }}
      className="animable"
    >
      <path
        d="M730.26,440.92H12.05a.5.5,0,0,1,0-1H730.26a.5.5,0,0,1,0,1Z"
        style={{
          fill: "rgb(38, 50, 56)",
          transformOrigin: "371.155px 440.42px 0px",
        }}
        id="elw21k5pbekxd"
        className="animable"
      />
    </g>
    <defs>
      <filter id="active" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#32DFEC" floodOpacity={1} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
      </filter>
      <filter id="hover" height="200%">
        <feMorphology
          in="SourceAlpha"
          result="DILATED"
          operator="dilate"
          radius={2}
        />
        <feFlood floodColor="#ff0000" floodOpacity={0.5} result="PINK" />
        <feComposite in="PINK" in2="DILATED" operator="in" result="OUTLINE" />
        <feMerge>
          <feMergeNode in="OUTLINE" />
          <feMergeNode in="SourceGraphic" />
        </feMerge>
        <feColorMatrix
          type="matrix"
          values="0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
        />
      </filter>
    </defs>
  </svg>
)
export default VisitCountAnimated
